import React, { useEffect, useState, forwardRef, useImperativeHandle, Ref, useCallback } from 'react';
import axios from '../../../utils/axiosExt';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import BadgesComponent from '../../../components/common/Badges';
import { ABDMDetails, coverage_details, create_facilitydetails, facility_enrollmentdetails, hierarchy_details, linkedRuralFacility, linkedUrbanFacility, linkedVillages, linkedWards, location_details, update_enrollmentdetails, update_facilitydetails, update_rural_hierarchy_details, update_urban_hierarchy_details, upgrade_enrollmentdetails, upgrade_facilitydetails, upgrade_hierarchy_details, upgrade_location_details, upgrade_rural_coverage_details, upgrade_rural_hierarchy_details, upgrade_urban_coverage_details, upgrade_urban_hierarchy_details } from './../../../constants'
import endpoints from '../../../config/endpoints';
import { decodeWithKeyAndShift } from '@utils/base64Utils';

import HealthFormField from './Form/HealthFormField';
import MapComponent from '../../GoogleMap/GoogleMapRender';
import Button from '../../../components/common/Button';
import CoverageCardComponent from '../../../components/common/CoverageCard';
import HFRVerify from '../../FacilityManagement/CreateNewFacility/FacilityDetails/HFRVerify';
import ABDMVerify from './ABDMDetails';
import './HealthfOverview.css'
import Radio from '../../../components/Radio/Radio';

import SelectionModal from '../../../stories/components/SelectionModal/index';

import calculateSimilarity from '../../../utils/fuzzyLogic';
import validateMapLocation from './../../../utils/validateMapLocation';
import Auth from './../../../utils/auth';
import config from './../../../config/config';
import LocationDetailsEdit from './LocationDetailsEdit';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { setGeometryMapPoint, setMapManualAddress, setMapLatLong, setMapManualLatLong, setMapManualLatLongClicked, setMapPincodeFirstTimeEdit, setCreateMapPincodeWithHfr, setMapServicesDown } from '@store/actions/facilityGeoMapAction';
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import dayjs from 'dayjs';
import { errorLogger } from '@utils/applicationLogUtils';
import { getDataWithCache, postDataJSON, putDataJSON } from '@services/CommonApiService';
import _ from 'lodash';
import { manageHealthFacilityJson } from '@utils/commonUtils';
import pako from 'pako';
import { encodeWithKeyAndShift, uint8ToBase64 } from '@utils/base64Utils';
import { USER_TYPES } from '@constants/userTypes';
import { checkUserRole, errorSuccessMessage, roleType } from '@constants/approvalConstants';
interface PropsType {
  user: any;
  flow: string;
  formData: {
    [key: string]: any;
  };
  facility: any;
  formState: any;
  handleFormChange: (value: string | boolean, key: string, id: any) => void;
};

interface objectType {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?: any,
  code?: number | [],
  verifiedDetails?: any,
}
interface formStateType {
  [key: string]: objectType
}

interface formDataType {
  [key: string]: any;
}

export interface ChildComponentHandlerUpdate {
  handleUpdateSave: () => void;
}

const HealthFacilityUpdateUi = forwardRef((props: PropsType, ref: Ref<ChildComponentHandlerUpdate>) => {
  const { user, flow, formData, formState, handleFormChange, facility } = props;
  const { id } = useParams();
  const navigate = useNavigate();
  const enableArcGISMap=config.enableArcGISMap;
  useImperativeHandle(ref, () => ({

    handleUpdateSave() {
      onHandleSave();

    }
  }));


  const encodedUserData = localStorage.getItem('userDetails');
  const LogedinUserDetails: any = encodedUserData ? JSON.parse(decodeWithKeyAndShift(encodedUserData)) : '';
  const encodedUserRoles = localStorage.getItem('userRoleDetails');
  const userRolesDetails = encodedUserRoles ? JSON.parse(decodeWithKeyAndShift(encodedUserRoles)).split(', ') : [];
  const roleData = checkUserRole(userRolesDetails)


  // code for map
  const dispatch = useDispatch();
  const facilityGeoMap = useSelector((state: RootState) => state.facilityGeoMap);
  

  const clearMapStore = () => {
    dispatch(setGeometryMapPoint({mapPointer: '', distFenceGeometry: ''}));
    dispatch(setMapManualAddress(false));
    dispatch(setMapLatLong(null));
    dispatch(setMapManualLatLong(false));
    dispatch(setMapManualLatLongClicked(false));
    dispatch(setMapPincodeFirstTimeEdit(null));
    dispatch(setCreateMapPincodeWithHfr(null))
    dispatch(setMapServicesDown(false));
  }
  //====================

  useEffect(() => {
    dispatch(setMapPincodeFirstTimeEdit(
      {
        flow: 'edit',
        firstTime: true
      }
    ));
  }, []);




  // Form 1
  const [formData1, setFormData1] = useState<any>(update_facilitydetails);
  const [locationDetailsFormData, setlocationDetailsFormData] = useState<any>(upgrade_location_details);
  const [status, setStatus] = useState<string>("");
  const [facilityDetailsFormState, setFacilityDetailsFormState] = useState<formStateType>({
    hpr_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      verifiedDetails: ''
    },
    facility_category: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: []
    },
    facility_name: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    },
    facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    ownership: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    administrative_body: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    central_govt_dept: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    rural_urban: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
  });

  //Form 2
  const [formData2, setFormData2] = useState<any>(update_enrollmentdetails);
  const [enrollmentDetailsFormState, setEnrollmentDetailsFormState] = useState<formStateType>({
    date_of_enrollment: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    effective_from_date: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    status: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    sanctionedbed_count: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    functionalbed_count: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    }
  });

  //Form 3 
  const [formData3_2, setFormData3_2] = useState<any>(update_rural_hierarchy_details);
  const [formData3_1, setFormData3_1] = useState<any>(update_urban_hierarchy_details);

  const [hierarchyDetailsRuralFormState, setHierarchyDetailsRuralFormState] = useState<formStateType>({
    state: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: undefined
    },
    district: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: undefined
    },
    sub_district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    health_block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    sub_division: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    village: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    gram_panchayat: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    parlimentary: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    lac: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
  });

  const [hierarchyDetailsUrbanFormState, setHierarchyDetailsUrbanFormState] = useState<formStateType>({
    state: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: undefined
    },
    district: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: undefined
    },
    ulb: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    sub_district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    health_block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    sub_division: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    ward: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    parlimentary: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    lac: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
  });
  const [locationDetailsFormState, setLocationDetailsFormState] = useState<formStateType>({
    pincode: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    lattitude: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    longitude: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    address: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
  });


  const [verify, setVerify] = useState<boolean>(false);
  const [clickVerify, setClickVerify] = useState<boolean>(false);
  const [abdmVerify, setABDMVerify] = useState<boolean>(false);
  const [abdmClickVerify, setABDMClickVerify] = useState<boolean>(false);
  const [abdmFacilityData, setabdmFacilityData] = useState<any>({});
  const [abdmLocalData, setABDMLocalData] = useState<any>({});
  const [latlngValidated, setlatlngValidated] = useState(false);
  const [ABDMdata, setABDMdata] = useState<any>({});

  const [linkedFacilitiesRuralSelected, setLinkedFacilitiesRuralSelected] = useState<any>([]);
  const [hfrIdCheck, setHfrCheck] = useState<string>('')
  const [facilityNameCheck, setFacilityNameCheck] = useState<string>('')
  const [linkedFacilitiesRural, setLinkedFacilitiesRural] = useState<any>([]);
  const [linkedFacilitiesUrban, setLinkedFacilitiesUrban] = useState<any>([]);
  const [linkedVillageRural, setLinkedVillageRural] = useState<any>([]);
  const [linkedGramPanchayatRural, setLinkedGramPanchayatRural] = useState<any>([]);
  const [linkedWardRural, setLinkedWardRural] = useState<any>([]);
  const [islinkedFacilitiesRuralError, setIslinkedFacilitiesRuralError] = useState(false);
  const [islinkedVillageRuralError, setIslinkedVillageRuralError] = useState(false);
  const [islinkedGramPanchayatRuralError, setIslinkedGramPanchayatRuralError] = useState(false);
  const [islinkedWardRuralError, setIslinkedWardRuralError] = useState(false);
  const [errorMessageCovLinkFacilities, setErrorMessageCovLinkFacilities] = useState<string>('');
  const [errorMessageCovLinkVillages, setErrorMessageCovLinkVillages] = useState<string>('');
  const [errorMessageCovLinkGramPanchayat, setErrorMessageCovLinkGramPanchayat] = useState<string>('');
  const [errorMessageCovLinkWard, setErrorMessageCovLinkWard] = useState<string>('');
  const [isUrbanOrRural, setIsUrbanOrRural] = useState<string>('');
  const [matchingScore, setMatchingScore] = useState<number>(70);
  const [stateCode, setStateCode] = useState<number>();
  const [distCode, setDistCode] = useState<number>();
  const [sourceType, setSourceType] = useState<string>();
  const [isSourceTypeAllowedToEdit, setIsSourceTypeAllowedToEdit] = useState<boolean>();
  const [effectiveDateChange, setEffectiveDateChange] = useState<boolean>(false);
  const [facilityDetailsChange, setFacilityDetailsChange] = useState<boolean>(false);
  const [hierarchyDetailsChange, setHierarchyDetailsChange] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [isFacilityTypeChanged, setIsFacilityTypeChanged] = useState<string>();
  const [isGrampanchayat, setIsGrampanchayat] = useState<boolean>(false);
  const [hfrIdError, setHfrIdError] = useState<boolean>(false);
  const [HBSDSelected, setHBSDSelected] = useState<boolean>(false); 
  const [ulbInputText, setUlbInputText] = useState<string>('');
  // Use Effect
  useEffect(() => {
    const fetchFacility = async () => {
      try {
       // const facility =facility //await axios.get(`${endpoints.getFacilityByFacilityId}/${id}`,Auth.loggedIn());
        //const faci = facility.data.data;
       // const facilityDetails = faci[0];
       const facilityDetails = facility;
       let grampanchayat:boolean=false;
        grampanchayat= facilityDetails?.isUsingGramPanchayat;
        setIsGrampanchayat(grampanchayat)  
       setIsFacilityTypeChanged(facilityDetails.facility_type_id)
       const facilityPayload={
        "facilityId":id,
        "facilityTypeId":facilityDetails.facility_type_id,
        "ruralOrUrbanId":facilityDetails.urban_rual_id,
        "adminBodyId":facilityDetails.admin_body_id,
        "isMigrated":facilityDetails.source_type==="Migration" && facilityDetails.is_allowed_edit_due_to_source_type,
        "ownershipId": facilityDetails.ownership_id,
       }
        const facilityDetailsInitialFetch = await axios.post(`${endpoints.facilityDetailsInitialFetch}`,facilityPayload,Auth.loggedInWithJSON());
        const facilityDetailsInitialFetchData=facilityDetailsInitialFetch?.data?.data;

        setStatus(facilityDetails.facility_status);
        setStateCode(facilityDetails.state_code);
        setDistCode(facilityDetails.district_code);
        setSourceType(facilityDetails.source_type);
        setIsSourceTypeAllowedToEdit(facilityDetails.is_allowed_edit_due_to_source_type);
        //check HF is migrated data or not
        if(facilityDetails.source_type==="Migration" && facilityDetails.is_allowed_edit_due_to_source_type){
          const today=new Date();
          setFormData2((facility_enrollmentdetails: { date_of_enrollment: any,effective_from_date:any }) => ({
            ...facility_enrollmentdetails,
            date_of_enrollment: {
              ...facility_enrollmentdetails.date_of_enrollment,
              '#isDisabled': false,
              '#required':true,
              '#maxDate':today.toISOString().split('T')[0],
              '#minDate':'1947-08-14'           
            }
          }));
          if (facilityDetails?.facility_type_id) {
          setFormData1((create_facilitydetails: { facility_type: any,ownership:any,administrative_body:any,central_govt_dept:any }) => ({
            ...create_facilitydetails,
            facility_type: {
              ...create_facilitydetails.facility_type,
              '#isDisabled': false,
              '#required':true,
            },
            ownership: {
              ...create_facilitydetails.ownership,
              '#isDisabled': false,
              '#required':true,
            },
            administrative_body: {
              ...create_facilitydetails.administrative_body,
              '#isDisabled': false,
              '#required':true,
            },
          }));
            try {
              const facility_OwnershipResponse =facilityDetailsInitialFetchData?.ownershipData// await axios.getWithCache(`${endpoints.getOwnerByFacilityTypeId}/${facilityDetails.facility_type_id}`, Auth.loggedIn());
              const facility_ownership_options = facility_OwnershipResponse.map((key: any) => ({
                value: key.ownership,
                label: key.ownership,
                id: key.owenership_id
              }));
              const facility_adminBody = facilityDetailsInitialFetchData?.adminBodyData//await axios.getWithCache(`${endpoints.getAdminBody}/${facilityDetails.facility_type_id}`, Auth.loggedIn());
              const facility_adminBody_options = facility_adminBody.map((key: any) => ({
                value: key.admin_body,
                label: key.admin_body,
                id: key.admin_body_id
              }));
              setFormData1((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
                ...create_facilitydetails,
                ownership: {
                  ...create_facilitydetails.ownership,
                  '#options': facility_ownership_options,
                  '#isDisabled': false,
                  '#required': true,
                },
                administrative_body: {
                  ...create_facilitydetails.administrative_body,
                  '#options': facility_adminBody_options,
                  '#isDisabled': false,
                  '#required': facility_adminBody_options.length > 0,
                },
              }));
            }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
          }
          else{
            setFormData1((create_facilitydetails: { facility_type: any,ownership:any,administrative_body:any,central_govt_dept:any }) => ({
              ...create_facilitydetails,
              facility_type: {
                ...create_facilitydetails.facility_type,
                '#isDisabled': false,
                '#required':true,
              }, 
            }));
          }
      }
        //get cat based on facility type id and R Or U ids.
        const facility_categoryResponse =facilityDetailsInitialFetchData?.categoryData //await axios.getWithCache(`${endpoints.getCategoryByFacilityId}/${id}`,Auth.loggedIn());
        const facility_value = facility_categoryResponse && facility_categoryResponse.map((value: any) => value.category);
        const facility_code = facility_categoryResponse && facility_categoryResponse.map((value: any) => value.facility_category_code);
        const facility_id = facility_categoryResponse && facility_categoryResponse.map((value: any) => value.ctegory_id);

        facilityDetails.urba_rural_name.toLowerCase() === 'rural' ? setIsUrbanOrRural('Rural') : setIsUrbanOrRural('Urban');
        setHfrCheck(facilityDetails.hfr_id);
        setFacilityNameCheck(facilityDetails.facility_name);
        //setting state - start
        // Form 1
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          facility_name: {
            ...facilityDetailsFormState.facility_name,
            value: facilityDetails.facility_name,
          },
          hpr_id: {
            ...facilityDetailsFormState.hpr_id,
            value: facilityDetails.hfr_id,
          },
          facility_type: {
            ...facilityDetailsFormState.facility_type,
            value: facilityDetails.facility_type,
            id: facilityDetails.facility_type_id
          },
          ownership: {
            ...facilityDetailsFormState.ownership,
            value: facilityDetails.owenership,
            id: facilityDetails.ownership_id
          },
          administrative_body: {
            ...facilityDetailsFormState.administrative_body,
            value: facilityDetails.admin_body,
            id: facilityDetails.admin_body_id
          },
          central_govt_dept: {
            ...facilityDetailsFormState.central_govt_dept,
            value: facilityDetails.central_govt_dept,
            id: facilityDetails.central_govt_dept_id
          },
          rural_urban: {
            ...facilityDetailsFormState.rural_urban,
            value: facilityDetails?.urba_rural_name === 'rural' ? 'Rural' : 'Urban',
            id: facilityDetails.urban_rual_id
          },
          facility_category: {
            ...facilityDetailsFormState.facility_category,
            value: facility_value,
            id: facility_id,
            code: facility_code
          }
        }));

        //Form 2
        setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
          ...enrollmentDetailsFormState,
          date_of_enrollment: {
            ...enrollmentDetailsFormState.date_of_enrollment,
            value:dayjs(facilityDetails.enrollment_dt).format('YYYY-MM-DD'),
          },
          effective_from_date: {
            ...enrollmentDetailsFormState.effective_from_date,
            value: dayjs(facilityDetails.effective_from_dt).format('YYYY-MM-DD'),
          },
          sanctionedbed_count: {
            ...enrollmentDetailsFormState.sanctionedbed_count,
            value: facilityDetails.sanctioned_bed_count,
          },
          functionalbed_count: {
            ...enrollmentDetailsFormState.functionalbed_count,
            value: facilityDetails.functional_bed_count,
          },
          status: {
            ...enrollmentDetailsFormState.functionalbed_count,
            value: facilityDetails.facility_status ? facilityDetails.facility_status : facilityDetails.status,
            id: facilityDetails.facility_status_id
          },
        }));

        //Form 3
        // if(facilityDetails.urba_rural_name === 'rural') {
        setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
          ...hierarchyDetailsRuralFormState,
          state: {
            ...hierarchyDetailsRuralFormState.state,
            value: `${facilityDetails.state_name}-${facilityDetails.state_code}`,
            id: facilityDetails.state_id,
            code: facilityDetails.state_code
          },
          district: {
            ...hierarchyDetailsRuralFormState.district,
            value: `${facilityDetails.district_name}-${facilityDetails.district_code}`,
            id: facilityDetails.district_id,
            code: facilityDetails.district_code
          },
          sub_district: {
            ...hierarchyDetailsRuralFormState.sub_district,
            value: facilityDetails.sub_district_name ? `${facilityDetails.sub_district_name}-${facilityDetails.sub_district_code}` : '',
            id: facilityDetails.sub_district_id,
            code: facilityDetails.sub_district_code
          },
          block: {
            ...hierarchyDetailsRuralFormState.block,
            value: facilityDetails.block_name ? `${facilityDetails.block_name}-${facilityDetails.block_code}` : '',
            id: facilityDetails.block_id,
            code: facilityDetails.block_code
          },
          health_block: {
            ...hierarchyDetailsRuralFormState.health_block,
            value: facilityDetails.health_block ? `${facilityDetails.health_block}-${facilityDetails.health_block_code}` : '',
            id: facilityDetails.health_block_id,
            code: facilityDetails.health_block_code
          },
          sub_division: {
            ...hierarchyDetailsRuralFormState.sub_division,
            value: facilityDetails.sub_division ? `${facilityDetails.sub_division}-${facilityDetails.sub_division_code}` : '',
            id: facilityDetails.sub_division_id,
            code: facilityDetails.sub_division_code
          },
          village: {
            ...hierarchyDetailsRuralFormState.village,
            value:facilityDetails.village_name ? `${facilityDetails.village_name}-${facilityDetails.village_code}` : '',
            id: facilityDetails?.village_id?facilityDetails?.village_id:'',
            code:facilityDetails?.village_code?facilityDetails?.village_code:''
          },
          gram_panchayat: {
            ...hierarchyDetailsRuralFormState.gram_panchayat,
            value: facilityDetails?.gram_panchayat_name ? `${facilityDetails?.gram_panchayat_name}-${facilityDetails?.gram_panchayat_code}` : '',
            id:  facilityDetails?.gram_panchayat_id?facilityDetails?.gram_panchayat_id:'' ,
            code:  facilityDetails?.gram_panchayat_code?facilityDetails?.gram_panchayat_code:''
          },
          parlimentary: {
            ...hierarchyDetailsRuralFormState.parlimentary,
            value: facilityDetails.urba_rural_name.toLowerCase() === 'rural' && facilityDetails.pac_name ? facilityDetails.pac_name : '',
            id: facilityDetails.pac_id,
            code: facilityDetails.pac_code
          },
          lac: {
            ...hierarchyDetailsRuralFormState.lac,
            value: facilityDetails.urba_rural_name.toLowerCase() === 'rural' && facilityDetails.lac_name ? facilityDetails.lac_name : '',
            id: facilityDetails.lac_id,
            code: facilityDetails.lac_code
          },
        }));
        // } else {
        setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
          ...hierarchyDetailsUrbanFormState,
          state: {
            ...hierarchyDetailsUrbanFormState.state,
            value: `${facilityDetails.state_name}-${facilityDetails.state_code}`,
            id: facilityDetails.state_id,
            code: facilityDetails.state_code
          },
          district: {
            ...hierarchyDetailsUrbanFormState.district,
            value: `${facilityDetails.district_name}-${facilityDetails.district_code}`,
            id: facilityDetails.district_id,
            code: facilityDetails.district_code
          },
          sub_district: {
            ...hierarchyDetailsUrbanFormState.sub_district,
            value: facilityDetails.sub_district_name ? `${facilityDetails.sub_district_name}-${facilityDetails.sub_district_code}` : '',
            id: facilityDetails.sub_district_id,
            code: facilityDetails.sub_district_code
          },
          ulb: {
            ...hierarchyDetailsUrbanFormState.ulb,
            value: facilityDetails.urba_rural_name.toLowerCase() === 'urban' && facilityDetails.ulb_name ? `${facilityDetails.ulb_name}-${facilityDetails.ulb_code}` : '',
            id: facilityDetails.ulb_id,
            code: facilityDetails.ulb_code
          },
          health_block: {
            ...hierarchyDetailsUrbanFormState.health_block,
            value: facilityDetails.health_block ? `${facilityDetails.health_block}-${facilityDetails.health_block_code}` : '',
            id: facilityDetails.health_block_id,
            code: facilityDetails.health_block_code
          },
          sub_division: {
            ...hierarchyDetailsUrbanFormState.sub_division,
            value: facilityDetails.sub_division ? `${facilityDetails.sub_division}-${facilityDetails.sub_division_code}` : '',
            id: facilityDetails.sub_division_id,
            code: facilityDetails.sub_division_code
          },
          ward: {
            ...hierarchyDetailsUrbanFormState.ward,
            value: facilityDetails.urba_rural_name.toLowerCase() === 'urban' && facilityDetails.ward_name ? `${facilityDetails.ulb_name}-${facilityDetails.ulb_code} - ${facilityDetails.ward_name}-${facilityDetails.ward_code}` : '',
            id: facilityDetails.ward_id,
            code: facilityDetails.ward_code
          },
          parlimentary: {
            ...hierarchyDetailsUrbanFormState.parlimentary,
            value: facilityDetails.urba_rural_name.toLowerCase() === 'urban' && facilityDetails.pac_name ? facilityDetails.pac_name : '',
            id: facilityDetails.pac_id,
            code: facilityDetails.pac_code
          },
          lac: {
            ...hierarchyDetailsUrbanFormState.lac,
            value: facilityDetails.urba_rural_name.toLowerCase() === 'urban' && facilityDetails.lac_name ? facilityDetails.lac_name : '',
            id: facilityDetails.lac_id,
            code: facilityDetails.lac_code
          }
        }));
        //form 4
        setLocationDetailsFormState((locationDetailsFormState: any) => ({
          ...locationDetailsFormState,
          pincode: {
            ...locationDetailsFormState.pincode,
            value: facilityDetails.pincode,
          },

          lattitude: {
            ...locationDetailsFormState.lattitude,
            value: facilityDetails.latitude,
          },
          longitude: {
            ...locationDetailsFormState.longitude,
            value: facilityDetails.longitude,
          },
          address: {
            ...locationDetailsFormState.address,
            value: facilityDetails.address,
          },

        }));

        // }
        //setting state - end

        //get API Urban or rural
        try {
          const ruralOrUrban = facilityDetailsInitialFetchData?.ruralOrUrbanData//await axios.getWithCache(`${endpoints.getRuralUrbal}`,Auth.loggedIn());
          const ruralOrUrban_options = ruralOrUrban.map((key: any) => (
            {
              value: key?.urban_rural_name === 'rural' ? 'Rural' : 'Urban',
              label: key?.urban_rural_name === 'rural' ? 'Rural' : 'Urban',
              id: key?.urban_rural_id
            }
          ));

          setFormData1((create_facilitydetails: { rural_urban: any }) => ({
            ...create_facilitydetails,
            rural_urban: {
              ...create_facilitydetails.rural_urban,
              '#options': ruralOrUrban_options,
            }
          }));

        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }

        //get API ALL facilitys
        try {
          const facility_typeResponse =facilityDetailsInitialFetchData?.facilityTypeData //await axios.getWithCache(endpoints.getFacilityType,Auth.loggedIn());

          const facility_type_options = facility_typeResponse.map((key: any) => ({
            value: key.facility_type,
            label: key.facility_type,
            id: key.facility_type_id
          }));

          setFormData1((create_facilitydetails: { facility_category: any; facility_type: any; ownership: any; }) => ({
            ...create_facilitydetails,
            facility_type: {
              ...create_facilitydetails.facility_type,
              '#options': facility_type_options,
            },
          }));
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }

        //get  category 
        try {
          const facility_categoryResponse =facilityDetailsInitialFetchData?.categoryData //await axios.getWithCache(`${endpoints.getCategoryByFacilityId}/${id}`,Auth.loggedIn());

          const facility_value = facility_categoryResponse && facility_categoryResponse.map((value: any) => value.category);
          const facility_code = facility_categoryResponse && facility_categoryResponse.map((value: any) => value.facility_category_code);
          const facility_id = facility_categoryResponse && facility_categoryResponse.map((value: any) => value.ctegory_id);

          const facility_category_options = facility_categoryResponse.map((key: any) => ({
            value: key.category,
            label: key.category,
            id: key.ctegory_id,
          }));
          if(facilityDetails.facility_type_id && facilityDetails.urban_rual_id){
          const facility_categoryResponse1 = facilityDetailsInitialFetchData?.categoryByFacilityTypeRuralorUrbanData//await axios.getWithCache(`${endpoints.getFacilityCatByFacilityTypeIdRuralOrUrban}/${facilityDetails.facility_type_id}/${facilityDetails.urban_rual_id}`,Auth.loggedIn());
          const facility_category_options1 = facility_categoryResponse1.map((key: any) => ({
          value: key?.facility_category,
          label: key?.facility_category,
          id: key?.facility_category_id,
          code:key?.facility_category_code,
        }));
          setFormData1((create_facilitydetails: { facility_category: any; }) => ({
            ...create_facilitydetails,
            facility_category: {
              ...create_facilitydetails.facility_category,
              '#options': facility_category_options1,
            }
          }));
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            facility_category: {
              ...facilityDetailsFormState.facility_category,
              value: facility_value,
              id: facility_id,
              code: facility_code
            }
          }))
        }
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
        //Get Status
        if(facilityDetails.facility_status!=='Inactive'){
          setFormData2((facility_enrollmentdetails: { status: any }) => ({
            ...facility_enrollmentdetails,
            status: {
              ...facility_enrollmentdetails.status,
              '#isDisabled': false,
              '#required':true
            }
          }));
        }
        try {
          const facility_status = await axios.getWithCache(`${endpoints.getFacilityStatus}`,Auth.loggedIn());

          const value = facility_status.data.data && facility_status.data.data.map((v: any) => ({
            value: v.status,
            label: v.status,
            id: v.satus_id,
          }));
          const updatedOptions = value.filter((option: any) => option.value !== 'Inactive');
          setFormData2((facility_enrollmentdetails: { status: any }) => ({
            ...facility_enrollmentdetails,
            status: {
              ...facility_enrollmentdetails.status,
              '#options': updatedOptions,
            }
          }));
         
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
        const data={
          "stateId":facilityDetails.state_id,
          "distId":facilityDetails.district_id,
          "pacId":facilityDetails.pac_id,
          "blockId":facilityDetails.block_id,
          "ulbId":facilityDetails.ulb_id,
          "isRural":facilityDetails.urba_rural_name.toLowerCase() === 'rural',
          "subDistId":facilityDetails.sub_district_id

      }
      const headerHierarchy:any=Auth.loggedInWithJSON();
      //headerHierarchy.headers['x-compress']="true"
        const hierarchyDetailsInitialFetch = await axios.post(`${endpoints.hierarchyDetailsInitialFetch}`,data,headerHierarchy);
        //const hierarchyDetailsInitialFetchData=JSON.parse(pako.inflate(hierarchyDetailsInitialFetch?.data?.data, { to: 'string' }));
        const hierarchyDetailsInitialFetchData=hierarchyDetailsInitialFetch?.data?.data;
         const getUlb = facilityDetails.urba_rural_name.toLowerCase() === 'urban' && hierarchyDetailsInitialFetchData?.ulbData//await axios.getWithCache(`${endpoints.getUlb}/${facilityDetails.state_id}`,Auth.loggedIn());
        //Get sub district
        const getDist=hierarchyDetailsInitialFetchData?.distData;
        const getSubDist:any = hierarchyDetailsInitialFetchData?.subDistData;
        const getHealthBlock:any = hierarchyDetailsInitialFetchData?.healthBlockData;
        const subDivision:any = hierarchyDetailsInitialFetchData?.subDivisionData;
        const getBlock:any = hierarchyDetailsInitialFetchData?.blockData;

        //if(facilityDetails.district_id){
        //getSubDist = await axios.getWithCache(`${endpoints.getSubDistricts}/${facilityDetails.district_id}`,Auth.loggedIn());
        //getHealthBlock = await axios.getWithCache(`${endpoints.getHealthBlock}/${facilityDetails.district_id}`,Auth.loggedIn());
       // subDivision = await axios.getWithCache(`${endpoints.getSubDivision}/${facilityDetails.district_id}`,Auth.loggedIn());
       // getBlock =facilityDetails.urba_rural_name.toLowerCase() === 'rural' && await axios.getWithCache(`${endpoints.getBlock}/${facilityDetails.district_id}`,Auth.loggedIn());
       // }
        setFormData3_1((hierarchy_details_urban: any) => ({
          ...hierarchy_details_urban,
          district: {
            ...hierarchy_details_urban.district,
            '#options': getDist,
            '#isDisabled': true
          },
          ulb: {
            ...hierarchy_details_urban.ulb,
            '#options':facilityDetails.urba_rural_name.toLowerCase() === 'urban' ? getUlb:[],
          },
          sub_district: {
            ...hierarchy_details_urban.sub_district,
            '#options': getSubDist,
            '#required':getSubDist.length > 0 ? true:false
          },
          health_block: {
            ...hierarchy_details_urban.health_block,
            '#options': getHealthBlock,
          },
          sub_division: {
            ...hierarchy_details_urban.sub_division,
            '#options': subDivision,
          }
        }));
        setFormData3_2((hierarchy_details_rural: any) => ({
          ...hierarchy_details_rural,
          district: {
            ...hierarchy_details_rural.district,
            '#options': getDist,
            '#isDisabled': true

          },
          sub_district: {
            ...hierarchy_details_rural.sub_district,
            '#options': getSubDist,
            '#required':getSubDist.length > 0 ? true:false
          },
          health_block: {
            ...hierarchy_details_rural.health_block,
            '#options': getHealthBlock,
          },
          sub_division: {
            ...hierarchy_details_rural.sub_division,
            '#options': subDivision,
          },
          block: {
            ...hierarchy_details_rural.block,
            '#options': facilityDetails.urba_rural_name.toLowerCase() === 'rural' ? getBlock:[],
            '#required':hierarchyDetailsInitialFetchData?.blockData?.length ? true : false,
          },
        }));
        setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
          ...hierarchyDetailsRuralFormState,
          sub_district: {
            ...hierarchyDetailsRuralFormState.sub_district,
            value: facilityDetails.sub_district_name ? `${facilityDetails.sub_district_name}-${facilityDetails.sub_district_code}` : '',
            id: facilityDetails.sub_district_id,
            code: facilityDetails.sub_district_code
          },

          health_block: {
            ...hierarchyDetailsRuralFormState.health_block,
            value: facilityDetails.health_block ? `${facilityDetails.health_block}-${facilityDetails.health_block_code}` : '',
            id: facilityDetails.health_block_id,
            code: facilityDetails.health_block_code
          },
          sub_division: {
            ...hierarchyDetailsRuralFormState.sub_division,
            value: facilityDetails.sub_division ? `${facilityDetails.sub_division}-${facilityDetails.sub_division_code}` : '',
            id: facilityDetails.sub_division_id,
            code: facilityDetails.sub_division_code
          },
          block: {
            ...hierarchyDetailsRuralFormState.block,
            value: facilityDetails.block_name ? `${facilityDetails.block_name}-${facilityDetails.block_code}`:'',
            id: facilityDetails.block_id,
            code: facilityDetails.block_code
          },

        }));
        setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
          ...hierarchyDetailsUrbanFormState,
          sub_district: {
            ...hierarchyDetailsUrbanFormState.sub_district,
            value: facilityDetails.sub_district_name ? `${facilityDetails.sub_district_name}-${facilityDetails.sub_district_code}` : '',
            id: facilityDetails.sub_district_id,
            code: facilityDetails.sub_district_code
          },
          health_block: {
            ...hierarchyDetailsUrbanFormState.health_block,
            value: facilityDetails.health_block ? `${facilityDetails.health_block}-${facilityDetails.health_block_code}` : '',
            id: facilityDetails.health_block_id,
            code: facilityDetails.health_block_code
          },
          sub_division: {
            ...hierarchyDetailsUrbanFormState.sub_division,
            value: facilityDetails.sub_division ? `${facilityDetails.sub_division}-${facilityDetails.sub_division_code}` : '',
            id: facilityDetails.sub_division_id,
            code: facilityDetails.sub_division_code
          },
        }));

        //ward
        try {
          if(facilityDetails.ulb_id){
          const getWard = hierarchyDetailsInitialFetchData.wardData//await axios.getWithCache(`${endpoints.getWard}/${facilityDetails.ulb_id}`,Auth.loggedIn());
          for (let i = 0; i < getWard.length; i++) {
            getWard[i].ward_name = `${facilityDetails.ulb_name}-${facilityDetails.ulb_code}-${getWard[i].ward_name}-${getWard[i].ward_code}`
          }
          setFormData3_1((hierarchy_details_urban: { ward: any }) => ({
            ...hierarchy_details_urban,
            ward: {
              ...hierarchy_details_urban.ward,
              '#options': getWard
            }
          }));
          setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
            ...hierarchyDetailsUrbanFormState,
            ward: {
              ...hierarchyDetailsUrbanFormState.ward,
              value:`${facilityDetails.ward_name}-${facilityDetails.ward_code}`,
              id: facilityDetails.ward_id,
              code: facilityDetails.ward_code,
            }
          }))
        }
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
        }
        //Village or Gram panchayat
        if(grampanchayat){
          setFormData3_2((hierarchy_details_rural: {gram_panchayat:any, village: any }) => ({
            ...hierarchy_details_rural,
            gram_panchayat: {
              ...hierarchy_details_rural.gram_panchayat,
              '#isVisible':true
            },
            village: {
              ...hierarchy_details_rural.village,
              '#isVisible':false
            },
          }))
        }
        else{
          setFormData3_2((hierarchy_details_rural: {gram_panchayat:any, village: any }) => ({
            ...hierarchy_details_rural,
            gram_panchayat: {
              ...hierarchy_details_rural.gram_panchayat,
              '#isVisible':false
            },
            village: {
              ...hierarchy_details_rural.village,
              '#isVisible':true
            },
          }))
        }
        try {
          if(facilityDetails.block_id){
            if(grampanchayat){
              const gramPanchayat =hierarchyDetailsInitialFetchData?.gramPanchayatData;
              const gramPanchayatOptions = gramPanchayat.map((option1: any) => ({
                value: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
                label: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
                id: option1.gram_panchayat_id,
                code:option1.gram_panchayat_code
              }));
              setFormData3_2((hierarchy_details_rural: {gram_panchayat:any, village: any }) => ({
                ...hierarchy_details_rural,
                gram_panchayat: {
                  ...hierarchy_details_rural.gram_panchayat,
                  '#options': gramPanchayatOptions,
                  '#required': gramPanchayat?.length ? true : false,
                },
              }))
            }
            else{
              const getVilage =hierarchyDetailsInitialFetchData?.villageData[0];
              const villageOptions = getVilage.map((option1: any) => ({
                value: `${option1.village_name}-${option1.village_code}`,
                label: `${option1.village_name}-${option1.village_code}`,
                id: option1.village_id,
                code:option1.village_code
              }));
              setFormData3_2((hierarchy_details_rural: { village: any }) => ({
                ...hierarchy_details_rural,
                village: {
                  ...hierarchy_details_rural.village,
                  '#options': villageOptions,
                  '#required': getVilage?.length ? true : false
                },
              }))
            }
        }
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
        }
        //PAC By Village Rural
        if (facilityDetails.urba_rural_name.toLowerCase() === 'rural') {
          try {
            const getPac =hierarchyDetailsInitialFetchData?.pacData; //await axios.getWithCache(`${endpoints.getPacByStateId}/${facilityDetails.state_id}`,Auth.loggedIn());
            setFormData3_2((hierarchy_details_rural: { parlimentary: any }) => ({
              ...hierarchy_details_rural,
              parlimentary: {
                ...hierarchy_details_rural.parlimentary,
                '#options': getPac
              }
            }));
            setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
              ...hierarchyDetailsRuralFormState,
              parlimentary: {
                ...hierarchyDetailsRuralFormState.parlimentary,
                value: facilityDetails.urba_rural_name.toLowerCase() === 'rural' && facilityDetails.pac_name ? facilityDetails.pac_name : '',
                id: facilityDetails.pac_id,
                code: facilityDetails.pac_code
              },
            }))
          }
          catch(error:any){
            errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
          }
        }

        //PAC By Ward Urban
        if (facilityDetails.urba_rural_name.toLowerCase() === 'urban') {
          try {
            if(facilityDetails.ward_id){
            const getPac = hierarchyDetailsInitialFetchData?.pacData;//await axios.getWithCache(`${endpoints.getPacByStateId}/${facilityDetails.state_id}`,Auth.loggedIn());            
            setFormData3_1((hierarchy_details_urban: { parlimentary: any }) => ({
              ...hierarchy_details_urban,
              parlimentary: {
                ...hierarchy_details_urban.parlimentary,
                '#options': getPac
              }
            }));
            setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
              ...hierarchyDetailsUrbanFormState,
              parlimentary: {
                ...hierarchyDetailsUrbanFormState.parlimentary,
                value: facilityDetails.urba_rural_name.toLowerCase() === 'urban' && facilityDetails.pac_name ? facilityDetails.pac_name : '',
                id: facilityDetails.pac_id,
                code: facilityDetails.pac_code
              },
            }))
          }
          }
          catch(error:any){
            errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
          }
        }
        //LAC 
        try {
          if(facilityDetails.pac_id){
          const getLac = hierarchyDetailsInitialFetchData?.lacData;//await axios.getWithCache(`${endpoints.getLacByPac}/${facilityDetails.pac_id}`,Auth.loggedIn());
          if (facilityDetails.urba_rural_name.toLowerCase() === 'urban') {
            setFormData3_1((hierarchy_details_urban: { lac: any }) => ({
              ...hierarchy_details_urban,
              lac: {
                ...hierarchy_details_urban.lac,
                '#options': getLac,
              }
            }));
            setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
              ...hierarchyDetailsUrbanFormState,
              lac: {
                ...hierarchyDetailsUrbanFormState.lac,
                value: facilityDetails.urba_rural_name.toLowerCase() === 'urban' && facilityDetails.lac_name ? facilityDetails.lac_name : '',
                id: facilityDetails.lac_id,
                code: facilityDetails.lac_code
              }
            }))
          }
          else {
            setFormData3_2((hierarchy_details_rural: { lac: any }) => ({
              ...hierarchy_details_rural,
              lac: {
                ...hierarchy_details_rural.lac,
                '#options': getLac,
              }
            }));
            setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
              ...hierarchyDetailsRuralFormState,
              lac: {
                ...hierarchyDetailsRuralFormState.lac,
                value: facilityDetails.urba_rural_name.toLowerCase() === 'rural' && facilityDetails.lac_name ? facilityDetails.lac_name : '',
                id: facilityDetails.lac_id,
                code: facilityDetails.lac_code
              }
            }))
          }
        }
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
        }
        //get Linked Facilities 
        if(grampanchayat){
          setLinkedGramPanchayatRural(facilityDetails?.linkedGramPanchayatRural);
          if(facilityDetails.health_block_id ||facilityDetails.sub_division_id){
            getSelectionGramPanchayats("","",facilityDetails.health_block_id,facilityDetails.sub_division_id)
          }
          else{
            getSelectionGramPanchayats(facilityDetails.block_id,facilityDetails.sub_district_id,"","")
          }
        }
        else{
          setLinkedVillageRural(facilityDetails?.linkedVillageRural);
          if(facilityDetails.health_block_id ||facilityDetails.sub_division_id){
            getSelectionVillages("","",facilityDetails.health_block_id,facilityDetails.sub_division_id)
          }
          else{
            getSelectionVillages(facilityDetails.block_id,facilityDetails.sub_district_id,"","")
          }
         
          // setVillagesCount(facilityDetails?.linkedVillageRural.length);//need to call api to fetch the villages
          // setVillages(facilityDetails?.linkedVillageRural);
          // setVillagesDetails(facilityDetails?.linkedVillageRural);  
        }
        setLinkedWardRural(facilityDetails.linkedWardRural);
        if(facilityDetails.health_block_id ||facilityDetails.sub_division_id){
          getSelectionWards("",facilityDetails.health_block_id,facilityDetails.sub_division_id)
        }
        else{
          getSelectionWards(facilityDetails.ulb_id,"","")
        }
        // setWardsCount(hierarchyDetailsInitialFetchData?.wardData.length)
        // setWards(hierarchyDetailsInitialFetchData?.wardData);
        // setWardsDetails(hierarchyDetailsInitialFetchData?.wardData);
        if (facilityDetails.urba_rural_name.toLowerCase() === 'rural' && facilityDetails.facility_type_id) {
         // const linkedFacilityRural = await axios.getWithCache(`${endpoints.getLinkedFacilitiesByFacilityId}/${id}`,Auth.loggedIn());
         // const villageRural = await axios.get(`${endpoints.getVillageByFacilityId}/${id}`,Auth.loggedIn());
          //setLinkedFacilitiesRural(linkedFacilityRural.data.data);
          //setLinkedVillageRural(villageRural.data.data);
          setLinkedFacilitiesRural(facilityDetails.linkedFacilitiesRural);
       
          getSelectionFacilitiesRural(facilityDetails.block_id,facilityDetails.facility_type_id);
          let linkedFaciltiesOptionsObject: any = {};
          const options2: string[] = facilityDetails.linkedFacilitiesRural;
          const linkedFaciltiesOptions: any = [];
          options2.map((option1: any) => {
            linkedFaciltiesOptions.push(option1?.facility_name)
          })
          linkedFaciltiesOptionsObject = linkedFaciltiesOptions.reduce((acc: any, current: any) => {
            if (!acc[current]) {
              acc[current] = current;
            }
            return acc;
          }, {});
          setLinkedFacilitiesRuralSelected(linkedFaciltiesOptionsObject)


        }
        if (facilityDetails.urba_rural_name.toLowerCase() === 'urban' && facilityDetails.facility_type_id) {
        //  const linkedFacilityRural = await axios.getWithCache(`${endpoints.getLinkedFacilitiesByFacilityId}/${id}`,Auth.loggedIn());
         // const wardUrban = await axios.get(`${endpoints.getWardByFacilityId}/${id}`,Auth.loggedIn());
          setLinkedFacilitiesUrban(facilityDetails.linkedFacilitiesUrban);
          getSelectionFacilitiesUrban(facilityDetails.ulb_id, facilityDetails.facility_type_id);
        }     
        Promise.resolve();
      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
      }
    }
    fetchFacility().then(() => {
      setLoading(false);
    });
    if(facility?.source_type==="Migration"){
          setFormData2((facility_enrollmentdetails: { date_of_enrollment: any,effective_from_date:any }) => ({
  ...facility_enrollmentdetails,
  effective_from_date: {
    ...facility_enrollmentdetails.effective_from_date,
    '#isDisabled': false,
    '#required':true,
    '#maxDate':new Date().toISOString().split('T')[0],
    '#minDate':dayjs().startOf('month')           
  }
}));
    }
  }, []);
   /* get Facility category and Type*/
   useEffect(() => {
     //checking whether the data is migrated or not
    if (sourceType==="Migration" && isSourceTypeAllowedToEdit && facilityDetailsChange) {
    const fetchFacilityType = async () => {
      try {
        const facility_typeResponse = await axios.get(endpoints.getFacilityType, Auth.loggedIn());
        const facility_type_options = facility_typeResponse.data.data.map((key: any) => ({
          value: key.facility_type,
          label: key.facility_type,
          id: key.facility_type_id
        }));

        setFormData1((create_facilitydetails: { facility_category: any; facility_type: any; ownership: any; }) => ({
          ...create_facilitydetails,
          facility_type: {
            ...create_facilitydetails.facility_type,
            '#options': facility_type_options,
          },

        }))
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          ownership: {
            ...facilityDetailsFormState.ownership,
            value: '',
            id:'',
            code:'',
          },
          administrative_body: {
            ...facilityDetailsFormState.administrative_body,
            value: '',
            id:'',
            code:'',
          },
          central_govt_dept: {
            ...facilityDetailsFormState.central_govt_dept,
            value: '',
            id:'',
            code:'',
          },
          facility_category: {
            ...facilityDetailsFormState.facility_category,
            value: [],
            id:[],
            code:[],
          },
        }));
      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
      }
    };
    fetchFacilityType();
    fetchOwnershipAdminbody(facilityDetailsFormState?.facility_type?.id);

  }
  }, [facilityDetailsFormState?.facility_type?.id]);
   /* Get Ownership and Administrative Body */
   const fetchOwnershipAdminbody = async (facilityTypeId:string) => {
    if (facilityTypeId) {
      try {
        const facility_OwnershipResponse = await axios.get(`${endpoints.getOwnerByFacilityTypeId(facilityTypeId)}`, Auth.loggedIn());
        const facility_ownership_options = facility_OwnershipResponse.data.data.map((key: any) => ({
          value: key.ownership,
          label: key.ownership,
          id: key.owenership_id
        }));
        setFormData1((create_facilitydetails: { ownership: any; administrative_body:any}) => ({
          ...create_facilitydetails,
          ownership: {
            ...create_facilitydetails.ownership,
            '#options': facility_ownership_options,
            '#isDisabled': false,
            '#required': true,
          },
          administrative_body: {
            ...create_facilitydetails.administrative_body,
            '#options': []
          },
        }));
      }
       catch(error:any){
          errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
        }
    } else {
      setFormData1((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
        ...create_facilitydetails,
        ownership: {
          ...create_facilitydetails.ownership,
          '#options': []
        },
        administrative_body: {
          ...create_facilitydetails.administrative_body,
          '#options': []
        },
      }));
    }
  };

  useEffect(()=>{
    const fetchAdminbody = async () =>{
      if (facilityDetailsFormState?.ownership?.id && facilityDetailsFormState?.facility_type?.id) {
        try {
          const facility_adminBody = await axios.get(`${endpoints.getAdminBody(facilityDetailsFormState?.facility_type?.id, facilityDetailsFormState?.ownership?.id)}`, Auth.loggedIn());
          const facility_adminBody_options = facility_adminBody.data.data.map((key: any) => ({
            value: key.admin_body,
            label: key.admin_body,
            id: key.admin_body_id
          }));

          setFormData1((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
            ...create_facilitydetails,
            administrative_body: {
              ...create_facilitydetails.administrative_body,
              '#options': facility_adminBody_options,
              '#isDisabled': false,
              '#required': facility_adminBody_options?.length > 0,
            },
          }));

          if (facility_adminBody_options?.length === 1) {
            if (sourceType==="Migration" && isSourceTypeAllowedToEdit && facilityDetailsChange) {
              const selectedAdminBody = facility_adminBody_options[0];
              setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
                ...facilityDetailsFormState,
                administrative_body: {
                  ...facilityDetailsFormState.administrative_body,
                  value: selectedAdminBody.value,
                  id: selectedAdminBody.id,
                },
              }));
            }
          }
          else{
            setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
              ...facilityDetailsFormState,
              administrative_body: {
                ...facilityDetailsFormState.administrative_body,
                value: '',
                id: '',
                code:'',
              },
            }));
          }
        } catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
        }
      }
      else {
        setFormData1((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
          ...create_facilitydetails,
          administrative_body: {
            ...create_facilitydetails.administrative_body,
            '#options': [],
          },
        }));
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          administrative_body: {
            ...facilityDetailsFormState.administrative_body,
            value: '',
            id: '',
            code:'',
          }
        }));
      }
    };

    fetchAdminbody();

  }, [facilityDetailsFormState?.ownership?.id])

   /*get Central Government Department*/
   useEffect(() => {
    //checking whether the data is migrated or not
    if (sourceType==="Migration" && isSourceTypeAllowedToEdit && facilityDetailsChange) {
      let facility_centralGovtDept;
      if (facilityDetailsFormState.administrative_body.id && facilityDetailsFormState.facility_type.id) {
        const fetchCentalGovtDept = async () => {
          try {
            facility_centralGovtDept = await axios.getWithCache(`${endpoints.getCentralGovtDeptByFacTypeIdAdminBodyId}/${facilityDetailsFormState.facility_type.id}/${facilityDetailsFormState.administrative_body.id}`, Auth.loggedIn());
            const facility_centralGovtDept_options = facility_centralGovtDept.data.data.map((key: any) => ({
              value: key.central_govt_dept_name,
              label: key.central_govt_dept_name,
              id: key.central_govt_dept_id
            }));
            if (facilityDetailsFormState.facility_type.value !== 'Defence Hospital' || facilityDetailsFormState.facility_type.value !== 'ESI Hospital' || facilityDetailsFormState.facility_type.value !== 'Railway Hospital') {
              if (facilityDetailsFormState.administrative_body.value !== "Central Government") {
                setFormData1((create_facilitydetails: { central_govt_dept: any }) => ({
                  ...create_facilitydetails,
                  central_govt_dept: {
                    ...create_facilitydetails.central_govt_dept,
                    '#options': [],
                    '#isDisabled': true,
                    '#required': false
                  }
                }))
              }
              else {
                if (facility_centralGovtDept.data.data.length !== 0) {
                  setFormData1((create_facilitydetails: { central_govt_dept: any }) => ({
                    ...create_facilitydetails,
                    central_govt_dept: {
                      ...create_facilitydetails.central_govt_dept,
                      '#options': facility_centralGovtDept_options,
                      '#isDisabled': false,
                      '#required': true,
                    }
                  }))
                }
                else {
                  setFormData1((create_facilitydetails: { central_govt_dept: any }) => ({
                    ...create_facilitydetails,
                    central_govt_dept: {
                      ...create_facilitydetails.central_govt_dept,
                      '#options': facility_centralGovtDept_options,
                      '#isDisabled': false,
                      '#required': false,
                    }
                  }))
                }
              }
            }
            else {
              if (facility_centralGovtDept.data.data.length !== 0) {
                setFormData1((create_facilitydetails: { central_govt_dept: any }) => ({
                  ...create_facilitydetails,
                  central_govt_dept: {
                    ...create_facilitydetails.central_govt_dept,
                    '#options': facility_centralGovtDept_options,
                    '#isDisabled': false,
                    '#required': true,
                  }
                }))
              }
              else {
                setFormData1((create_facilitydetails: { central_govt_dept: any }) => ({
                  ...create_facilitydetails,
                  central_govt_dept: {
                    ...create_facilitydetails.central_govt_dept,
                    '#options': facility_centralGovtDept_options,
                    '#isDisabled': false,
                    '#required': false,
                  }
                }))
              }
            }
          }
          catch(error:any){
            errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
          }
        }
        fetchCentalGovtDept();
      }
      else {
        setFormData1((create_facilitydetails: { central_govt_dept: any }) => ({
          ...create_facilitydetails,
          central_govt_dept: {
            ...create_facilitydetails.central_govt_dept,
            '#options': [],
            '#isDisabled': true,
            '#required': false
          }
        }))
      }
  }
  }, [facilityDetailsFormState?.facility_type?.id, facilityDetailsFormState?.administrative_body?.value]);
 //Effective From Date for migrated data
 useEffect(() => {
  const effectiveFromDate = async () => {
    try {
      const getEntrollmentDate = enrollmentDetailsFormState.date_of_enrollment.value; 
      if (sourceType==="Migration" && isSourceTypeAllowedToEdit && effectiveDateChange) {
        const today = new Date();
        const maxDate = today.toISOString().split('T')[0];
        const oneYearAgo = new Date();
        oneYearAgo.setDate(today.getDate() - 365);
        const oneYearAgoDate = oneYearAgo.toISOString().split('T')[0];
        if (dayjs(getEntrollmentDate).format('YYYY-MM-DD') >= oneYearAgoDate && dayjs(getEntrollmentDate).format('YYYY-MM-DD') <= maxDate) {
        setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
          ...enrollmentDetailsFormState,
          effective_from_date: {
            ...enrollmentDetailsFormState.effective_from_date,
            value: getEntrollmentDate,
          }
        }))
      }else{
        setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
          ...enrollmentDetailsFormState,
          effective_from_date: {
            ...enrollmentDetailsFormState.effective_from_date,
            isDisable: false,
            value: '',
          }
        }))
      }
    }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
    }
  }
  effectiveFromDate();

}
  , [enrollmentDetailsFormState.date_of_enrollment.value]);

  useEffect(() => {
    if(hierarchyDetailsChange){
    hierarchyDetailsUrbanFormState?.ulb?.id && getWardList(hierarchyDetailsUrbanFormState?.ulb?.id, hierarchyDetailsUrbanFormState?.ulb?.code, hierarchyDetailsUrbanFormState?.ulb?.value);
    setLinkedFacilitiesUrban([]);
    getSelectionFacilitiesUrban(hierarchyDetailsUrbanFormState.ulb.id, facilityDetailsFormState.facility_type.id);
    setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
      ...hierarchyDetailsUrbanFormState,
      ward: {
        ...hierarchyDetailsUrbanFormState.ward,
        value: '',
        id: '',
        code: '',
      },
    }));
    if(!hierarchyDetailsUrbanFormState.ulb.id){
      setLinkedFacilities([]);
      setLinkedFacilitiesCount(0);
      setFormData3_1((hierarchy_details_urban: any) => ({
        ...hierarchy_details_urban,
        ward: {
          ...hierarchy_details_urban.ward,
          '#options': [],
        },
      }));
    }
    }
  }, [hierarchyDetailsUrbanFormState.ulb.id]);

  useEffect(()=>{
    if(facilityDetailsFormState?.rural_urban?.value?.toLowerCase() === 'urban' && hierarchyDetailsChange){
      if(!hierarchyDetailsUrbanFormState?.ulb?.id && !hierarchyDetailsUrbanFormState?.health_block?.id && !hierarchyDetailsUrbanFormState?.sub_division?.id){
        setVillages([]);
        setVillagesCount(0);
        setLinkedVillageRural([]);
        setGramPanchayatCount(0);
        setGramPanchayats([]);
        setLinkedGramPanchayatRural([]);
        setLinkedWardRural([]);  
        setWards([]);
        setWardsCount(0);
      }
      const healthBlockId=hierarchyDetailsUrbanFormState?.health_block?.id;
      const subDivisionId=hierarchyDetailsUrbanFormState?.sub_division?.id;
      if(!healthBlockId && !subDivisionId){
        setVillages([]);
        setVillagesCount(0);
        setLinkedVillageRural([]);
        setGramPanchayatCount(0);
        setGramPanchayats([]);
        setLinkedGramPanchayatRural([]);
        setLinkedWardRural([]);  
        setWards([]);
        setWardsCount(0);
        getSelectionWards(hierarchyDetailsUrbanFormState?.ulb?.id,"","");
      }
    }
  },[hierarchyDetailsUrbanFormState?.ulb?.id])
  
  useEffect(()=>{
    if(hierarchyDetailsChange){
      const healthBlockId =facilityDetailsFormState?.rural_urban?.value==='Rural'? hierarchyDetailsRuralFormState?.health_block?.id:hierarchyDetailsUrbanFormState?.health_block?.id;
      const subDivisionId =facilityDetailsFormState?.rural_urban?.value==='Rural'? hierarchyDetailsRuralFormState?.sub_division?.id:hierarchyDetailsUrbanFormState?.sub_division?.id;
      setVillages([]);
      setVillagesCount(0);
      setLinkedVillageRural([]);
      setGramPanchayatCount(0);
      setGramPanchayats([]);
      setLinkedGramPanchayatRural([]);
      setLinkedWardRural([]);  
      setWards([]);
      setWardsCount(0); 
      if(!healthBlockId && !subDivisionId){
        if(facilityDetailsFormState?.rural_urban?.value==='Rural'){
          isGrampanchayat?getSelectionGramPanchayats(hierarchyDetailsRuralFormState?.block?.id,hierarchyDetailsRuralFormState.sub_district.id,"",""):getSelectionVillages(hierarchyDetailsRuralFormState?.block?.id,hierarchyDetailsRuralFormState.sub_district.id,"","");
        }
        else if(facilityDetailsFormState?.rural_urban?.value==='Urban'){
          getSelectionWards(hierarchyDetailsUrbanFormState?.ulb?.id,"","");
        }
      }
      else{
        getSelectionWards("",healthBlockId,subDivisionId);
        isGrampanchayat?getSelectionGramPanchayats("","",healthBlockId,subDivisionId):getSelectionVillages("","",healthBlockId,subDivisionId);
      }
    }
  },[hierarchyDetailsRuralFormState?.health_block?.id, hierarchyDetailsRuralFormState?.sub_division?.id, hierarchyDetailsUrbanFormState?.health_block?.id, hierarchyDetailsUrbanFormState?.sub_division?.id])
 
  useEffect(() => {
    if(hierarchyDetailsChange){
    getSubDistHBlockSubDivisionRural(hierarchyDetailsRuralFormState.district.id)
    }
  }, [hierarchyDetailsRuralFormState.district.id])
  // useEffect(() => {
  //   
  // }, [facilityDetailsFormState.facility_category.id])
  useEffect(() => {
    if(hierarchyDetailsChange){
    getSubDistHBlockSubDivisionRural(hierarchyDetailsUrbanFormState.district.id)
    }
  }, [hierarchyDetailsUrbanFormState.district.id])

  useEffect(()=>{
    if(hierarchyDetailsUrbanFormState?.state?.id && ulbInputText?.length >= 3){
      getUlb(hierarchyDetailsUrbanFormState?.state?.id, ulbInputText)
    }
    if(ulbInputText?.length === 0)
    {
      setFormData3_1((hierarchy_details_urban: any) => ({
        ...hierarchy_details_urban,
        ulb: {
          ...hierarchy_details_urban.ulb,
          '#options': [],
        },
      }));
    }
  },[ulbInputText])
  
  const getUlb = async (stateId : any, ulbInputText:string) => {
    try{
      const getUlbwithsearch = await axios.get(`${endpoints.fetchUlbByStateIdAndSearch(stateId,ulbInputText)}`, Auth.loggedIn());
      const getUlbOptions = getUlbwithsearch?.data.data
      setFormData3_1((hierarchy_details_urban: any) => ({
        ...hierarchy_details_urban,
        ulb: {
          ...hierarchy_details_urban.ulb,
          '#options': getUlbOptions,
        },
      }));
      setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
        ...hierarchyDetailsUrbanFormState,
        ulb: {
          ...hierarchyDetailsUrbanFormState.ulb,
          value: '',
          id: '',
          code: ''
        },
        ward: {
          ...hierarchyDetailsUrbanFormState.ward,
          value: '',
          id: '',
          code: ''
        },
      }));
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
    }
  }
  const getBlock = async (distId : any) => {
    try{
      const getBlockRes = await axios.getWithCache(`${endpoints.getBlock(distId)}`, Auth.loggedIn());
      const getBlockOptions = getBlockRes?.data.data;
      setFormData3_2((hierarchy_details_rural: any ) => ({
        ...hierarchy_details_rural,
        block: {
          ...hierarchy_details_rural.block,
          '#options': getBlockOptions,
        },
      }));
      setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
        ...hierarchyDetailsRuralFormState,
        block: {
          ...hierarchyDetailsRuralFormState.block,
          value: '',
          id: '',
          code: ''
        },
        village: {
          ...hierarchyDetailsRuralFormState.village,
          value: '',
          id: '',
          code: ''
        },
        gram_panchayat: {
          ...hierarchyDetailsRuralFormState.gram_panchayat,
          value: '',
          id: '',
          code: ''
        },
      }));
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
    }
  }
  const resetVillageGramPanchayat=()=>{
    setFormData3_2((role_details:any) => ({
      ...role_details,
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': [],
      },
      village: {
        ...role_details.village,
        '#options': [],
      },
    }))
    setHierarchyDetailsRuralFormState((roleFormState:any) => ({
      ...roleFormState,
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
        code: ''
      },
      village: {
        ...roleFormState.village,
        value: '',
        id: '',
        code: ''
      },
    }))
      setVillages([]);
      setVillagesCount(0);
      setLinkedVillageRural([]);
      setGramPanchayatCount(0);
      setGramPanchayats([]);
      setLinkedGramPanchayatRural([]);
  }
  useEffect(() => {
    if(facilityDetailsChange){
      getCatgory(facilityDetailsFormState.facility_type.id, facilityDetailsFormState.rural_urban.id);
      if(facilityDetailsFormState.rural_urban.value?.toLowerCase() !== facility.urba_rural_name){
        if(facilityDetailsFormState.rural_urban.value?.toLowerCase() === 'urban'){
          getUlb(facility.state_id, ulbInputText);
        }
        if(facilityDetailsFormState.rural_urban.value?.toLowerCase() === 'rural'){
          getBlock(facility.district_id);
        }
      }
    }
  }, [facilityDetailsFormState.facility_type.id, facilityDetailsFormState.rural_urban.id])

  useEffect(()=>{
    if(facilityDetailsFormState.rural_urban.value?.toLowerCase() === 'urban')
    {
      if(!hierarchyDetailsUrbanFormState?.ulb?.id ){
        setLinkedFacilities([]);
        setLinkedFacilitiesCount(0);
      }
    }
    if(facilityDetailsFormState.rural_urban.value?.toLowerCase() === 'rural'){
      if(!hierarchyDetailsRuralFormState?.block?.id ){
        setLinkedFacilities([]);
        setLinkedFacilitiesCount(0);
      }
    }
  },[facilityDetailsFormState.rural_urban.id])

  useEffect(() => {
    if(hierarchyDetailsChange){
    getPAC(hierarchyDetailsUrbanFormState.state.id);
    }
  }, [hierarchyDetailsUrbanFormState.state.id]);

  useEffect(() => {
    if(hierarchyDetailsChange){
    getLAC(hierarchyDetailsUrbanFormState.parlimentary.id);
    }
  }, [hierarchyDetailsUrbanFormState.parlimentary.id,hierarchyDetailsUrbanFormState.parlimentary.value]);
  useEffect(() => {
    if(hierarchyDetailsChange){
    getLAC(hierarchyDetailsRuralFormState.parlimentary.id);
    }
  }, [hierarchyDetailsRuralFormState.parlimentary.id, hierarchyDetailsRuralFormState.parlimentary.value]);

   useEffect(() => {
    if(hierarchyDetailsChange){
      if(hierarchyDetailsRuralFormState.block?.id && (formData3_2?.sub_district['#required'] == true ?  hierarchyDetailsRuralFormState.sub_district.id : true)){
        isGrampanchayat?getGramPanchayat(hierarchyDetailsRuralFormState.block?.id):getVillage(hierarchyDetailsRuralFormState.block?.id);
        }
      resetVillageGramPanchayat();
      setLinkedFacilitiesRural([]);
      setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
        ...hierarchyDetailsRuralFormState,
        village: {
          ...hierarchyDetailsRuralFormState.village,
          value: '',
          id: '',
          code: '',
        }
      }));
      if(!hierarchyDetailsRuralFormState?.block?.id){
        setLinkedFacilities([]);
        setLinkedFacilitiesCount(0);
        setFormData3_2((hierarchy_details_rural: any) => ({
          ...hierarchy_details_rural,
          village: {
            ...hierarchy_details_rural.village,
            '#options': [],
          },
       
      }));
    }
  }
  }, [hierarchyDetailsRuralFormState.block.id,hierarchyDetailsRuralFormState.sub_district.id]);

  useEffect(()=>{
    if(facilityDetailsFormState?.rural_urban?.value?.toLowerCase() === 'rural' && hierarchyDetailsChange){
      if(!hierarchyDetailsRuralFormState?.block?.id && !hierarchyDetailsRuralFormState?.health_block?.id && !hierarchyDetailsRuralFormState?.sub_division?.id){
        setVillages([]);
        setVillagesCount(0);
        setLinkedVillageRural([]);
        setGramPanchayatCount(0);
        setGramPanchayats([]);
        setLinkedGramPanchayatRural([]);
        setLinkedWardRural([]);  
        setWards([]);
        setWardsCount(0); 
      } 
      const healthBlockId=hierarchyDetailsRuralFormState?.health_block?.id;
      const subDivisionId=hierarchyDetailsRuralFormState?.sub_division?.id;
      if(!healthBlockId && !subDivisionId){ 
        setVillages([]);
        setVillagesCount(0);
        setLinkedVillageRural([]);
        setGramPanchayatCount(0);
        setGramPanchayats([]);
        setLinkedGramPanchayatRural([]);
        setLinkedWardRural([]);  
        setWards([]);
        setWardsCount(0);
        isGrampanchayat?getSelectionGramPanchayats(hierarchyDetailsRuralFormState?.block?.id,hierarchyDetailsRuralFormState.sub_district.id,"",""):getSelectionVillages(hierarchyDetailsRuralFormState?.block?.id,hierarchyDetailsRuralFormState.sub_district.id,"","");
      }
    }
  },[hierarchyDetailsRuralFormState?.block?.id])
 
  useEffect(()=>{
    if(enrollmentDetailsFormState.sanctionedbed_count.value===null || enrollmentDetailsFormState.sanctionedbed_count.value==='0' ||
      enrollmentDetailsFormState.sanctionedbed_count.value===''
    ){
      setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
        ...enrollmentDetailsFormState,
        functionalbed_count: {
          ...enrollmentDetailsFormState.functionalbed_count,
          value:''
        }
      }));
      setFormData2((facility_enrollmentdetails: { functionalbed_count: any }) => ({
        ...facility_enrollmentdetails,
        functionalbed_count: {
          ...facility_enrollmentdetails.functionalbed_count,
          '#isDisabled':true
          
        }
      }));
    }
    else {
      setFormData2((facility_enrollmentdetails: { functionalbed_count: any }) => ({
        ...facility_enrollmentdetails,
        functionalbed_count: {
          ...facility_enrollmentdetails.functionalbed_count,
          '#isDisabled':false
          
        }
      }));
    }
  
  },[enrollmentDetailsFormState.sanctionedbed_count.value])

  useEffect(() => {
    if(hierarchyDetailsChange){
    hierarchyDetailsRuralFormState.state.id && getPacByState(hierarchyDetailsRuralFormState.state.id);
    }
  }, [hierarchyDetailsRuralFormState.state.id]);
  const getSubDistHBlockSubDivisionRural = async (districtId: any) => {
    try {
      if(districtId){
      const getSubDist = await axios.getWithCache(`${endpoints.getSubDistricts(districtId)}`,Auth.loggedIn());
      const getHealthBlock = await axios.getWithCache(`${endpoints.getHealthBlock(districtId)}`,Auth.loggedIn());
      const subDivision = await axios.getWithCache(`${endpoints.getSubDivision(districtId)}`,Auth.loggedIn());
      const getBlock = await axios.getWithCache(`${endpoints.getBlock(districtId)}`,Auth.loggedIn());

      setFormData3_2((hierarchy_details_rural: any) => ({
        ...hierarchy_details_rural,
        sub_district: {
          ...hierarchy_details_rural.sub_district,
          '#options': getSubDist.data.data,
        },
        health_block: {
          ...hierarchy_details_rural.health_block,
          '#options': getHealthBlock.data.data,
        },
        sub_division: {
          ...hierarchy_details_rural.sub_division,
          '#options': subDivision.data.data,
        },
        block: {
          ...hierarchy_details_rural.block,
          '#options': getBlock.data.data,
          '#required': getBlock?.data?.data?.length ? true :false,
        },
        village: {
          ...hierarchy_details_rural.village,
          '#options': [],
        },
        gram_panchayat: {
          ...hierarchy_details_rural.gram_panchayat,
          '#options': [],
        },
        // parlimentary: {
        //   ...hierarchy_details_rural.parlimentary,
        //   '#options': [],
        // },
        // lac: {
        //   ...hierarchy_details_rural.lac,
        //   '#options': [],
        // },
      }));
      setFormData3_1((hierarchy_details_urban: any) => ({
        ...hierarchy_details_urban,
        sub_district: {
          ...hierarchy_details_urban.sub_district,
          '#options': getSubDist.data.data,
        },
        health_block: {
          ...hierarchy_details_urban.health_block,
          '#options': getHealthBlock.data.data,
        },
        sub_division: {
          ...hierarchy_details_urban.sub_division,
          '#options': subDivision.data.data,
        }
      }));

      setHierarchyDetailsRuralFormState((HierarchyDetailsRuralFormState: any) => ({
        ...HierarchyDetailsRuralFormState,
        sub_district: {
          ...HierarchyDetailsRuralFormState.sub_district,
          value: '',
          id: '',
        },
        health_block: {
          ...HierarchyDetailsRuralFormState.health_block,
          value: '',
          id: '',
        },
        sub_division: {
          ...HierarchyDetailsRuralFormState.health_block,
          value: '',
          id: '',
        },
        block: {
          ...HierarchyDetailsRuralFormState.block,
          value: '',
          id: '',
        },
        village: {
          ...HierarchyDetailsRuralFormState.village,
          value: '',
          id: '',
          code:''
        },
        gram_panchayat: {
          ...HierarchyDetailsRuralFormState.gram_panchayat,
          value: '',
          id: '',
          code: ''
        },
        // parlimentary: {
        //   ...HierarchyDetailsRuralFormState.parlimentary,
        //   value: '',
        //   id: '',
        // },
        // lac: {
        //   ...HierarchyDetailsRuralFormState.lac,
        //   value: '',
        //   id: '',
        // }
      }))
      setHierarchyDetailsUrbanFormState((HierarchyDetailsRuralFormState: any) => ({
        ...HierarchyDetailsRuralFormState,
        sub_district: {
          ...HierarchyDetailsRuralFormState.sub_district,
          value: '',
          id: '',
        },
        health_block: {
          ...HierarchyDetailsRuralFormState.health_block,
          value: '',
          id: '',
        },
        sub_division: {
          ...HierarchyDetailsRuralFormState.health_block,
          value: '',
          id: '',
        }
      }))
    }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
    }
  }
  const getCatgory = async (facilityTypeId: any, urbanOrRuralId: any) => {
    try {
      if(facilityTypeId && urbanOrRuralId){
      const facility_categoryResponse = await axios.getWithCache(`${endpoints.getFacilityCatByFacilityTypeIdRuralOrUrban(facilityTypeId,urbanOrRuralId)}`,Auth.loggedIn());
      const facility_category_options = facility_categoryResponse.data.data.map((key: any) => ({
        value: key.facility_category,
        label: key.facility_category,
        id: key.facility_category_id,
        code: key.facility_category_code,
      }));

      setFormData1((create_facilitydetails: { facility_category: any; ownership: any; }) => ({
        ...create_facilitydetails,
        facility_category: {
          ...create_facilitydetails.facility_category,
          '#options': facility_category_options,
        }
      }));
      setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
        ...facilityDetailsFormState,
        facility_category: {
          ...facilityDetailsFormState.facility_category,
          value: [],
          id: [],
          code: []
        }
      }))
    }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
    }
  }
  const getVillage = async (blockId: any) => {
    try {
      if(blockId){
        const postData = {
          p_state_id: facility.state_id,
          p_dist_id: facility.district_id,
          p_sub_dist_ids: hierarchyDetailsRuralFormState?.sub_district?.id ? [hierarchyDetailsRuralFormState.sub_district?.id] : [],
          p_block_ids: [blockId],
          p_hbsd_ids: [],
        }
      
      const getVillage = await axios.post(`${endpoints.getVillagesByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
      const villageOptions = getVillage?.data.data.map((option1: any) => ({
        value: `${option1.village_name}-${option1.village_code}`,
        label: `${option1.village_name}-${option1.village_code}`,
        id: option1.village_id,
        code:option1.village_code
      }));
      setFormData3_2((hierarchy_details_rural: {parlimentary: any; lac: any; village: any }) => ({
        ...hierarchy_details_rural,
        village: {
          ...hierarchy_details_rural.village,
          '#options': villageOptions,
          '#required': villageOptions?.length? true : false,
        },
      }))
      setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
        ...hierarchyDetailsRuralFormState,
        village: {
          ...hierarchyDetailsRuralFormState.village,
          value: '',
          id: '',
          code:''
        },
        // parlimentary: {
        //   ...hierarchyDetailsRuralFormState.parlimentary,
        //   value: '',
        //   id: '',
        // },
        // lac: {
        //   ...hierarchyDetailsRuralFormState.lac,
        //   value: '',
        //   id: '',
        // }
      }))
      setVillagesPayLoad({
          'blockId': blockId,
          'healthBlockId': '',
          'subDivisionId': '',
        });
      const villagesCoveredOptions: any = [];
      getVillage?.data?.data?.map((e: any) => {
        villagesCoveredOptions.push(e?.village_name)
      })
      setVillagesCount(getVillage?.data?.meta?.numberOfRecords);
      setVillages(getVillage?.data?.data);
      setVillagesDetails(getVillage?.data?.data);
      }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
    }
  }
   //gram panchayat fetching API
   const getGramPanchayat=async (blockId:any)=>{
    try{
      if(blockId){
       const postData = {
          p_state_id: facility.state_id,
          p_dist_id: facility.district_id,
          p_sub_dist_ids: hierarchyDetailsRuralFormState?.sub_district?.id ? [hierarchyDetailsRuralFormState.sub_district?.id] : [],
          p_block_ids: [blockId],
          p_hbsd_ids: [],
      }
    const gramPanchayat = await axios.post(`${endpoints.getGrampanchayatByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());         
    // const gramPanchayat = await getDataWithCache<any>(`${endpoints.getGramPanchayatByBlockId(blockId)}`);
    const gramPanchayatOptions = gramPanchayat?.data?.data.map((option1: any) => ({
      value: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
      label: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
      id: option1.gram_panchayat_id,
      code:option1.gram_panchayat_code
    }));
    setFormData3_2((role_details:any) => ({
      ...role_details,
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': gramPanchayatOptions,
        '#required': gramPanchayatOptions?.length  ? true : false,
      },

    }))
    setHierarchyDetailsRuralFormState((roleFormState:any) => ({
      ...roleFormState,
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
        code: ''
      },
    }))
      const gramPanchayatCoveredOptions: any = [];
      gramPanchayat?.data?.data?.map((e: any) => {
        gramPanchayatCoveredOptions?.push(e.gram_panchayat_name)
      })
      setGramPanchayatCount(gramPanchayat?.data?.meta?.numberOfRecords);
      setGramPanchayats(gramPanchayat?.data?.data);
      setGramPanchayatsDetails(gramPanchayat?.data?.data);
  }
  }catch(error:any){
            errorLogger(error?.response?.data||error?.response||error)
    }
  }
  const getPacByState = async (stateId: any) => {
    if(stateId){
    const getPAC = await axios.getWithCache(`${endpoints.getPacByStateId(stateId)}`,Auth.loggedIn());    
    setFormData3_2((hierarchy_details_rural: any) => ({
      ...hierarchy_details_rural,
      parlimentary: {
        ...hierarchy_details_rural.parlimentary,
        '#options': getPAC.data.data,
      },
      lac: {
        ...hierarchy_details_rural.lac,
        '#options': [],
      },
    }));
    setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
      ...hierarchyDetailsRuralFormState,
      // parlimentary: {
      //   ...hierarchyDetailsRuralFormState.parlimentary,
      //   value: '',
      //   id: '',
      // },
      lac: {
        ...hierarchyDetailsRuralFormState.lac,
        value: '',
        id: '',
      }
    }))
  }
  }

  const getWardList = async (ulbId: any, ulbCode: any, ulbName: any) => {
    try {
      if(ulbId){
      const selectedULB = hierarchyDetailsUrbanFormState.ulb.value;
      const selectedULBCode = hierarchyDetailsUrbanFormState.ulb.code;
      const getWard = await axios.getWithCache(`${endpoints.getWard(ulbId)}`,Auth.loggedIn());
      
      for (let i = 0; i < getWard.data.data.length; i++) {
        getWard.data.data[i].ward_name = `${ulbName}-${getWard.data.data[i].ward_name}-${getWard.data.data[i].ward_code}`
      }

      setFormData3_1((hierarchy_details_urban: { ward: any;parlimentary:any;lac:any }) => ({
        ...hierarchy_details_urban,
        ward: {
          ...hierarchy_details_urban.ward,
          '#options': getWard.data.data
        },
        // parlimentary: {
        //   ...hierarchy_details_urban.parlimentary,
        //   '#options': [],
        // },
        // lac: {
        //   ...hierarchy_details_urban.lac,
        //   '#options': [],
        // },
      }));
      setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
        ...hierarchyDetailsUrbanFormState,
        ward: {
          ...hierarchyDetailsUrbanFormState.ward,
          value: '',
          id: '',
        },
        // parlimentary: {
        //   ...hierarchyDetailsUrbanFormState.parlimentary,
        //   value: '',
        //   id: '',
        // },
        // lac: {
        //   ...hierarchyDetailsUrbanFormState.lac,
        //   value: '',
        //   id: '',
        // }
      }))
    }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
    }

  }

  const getPAC = async (stateID: any) => {
    try {
      if(stateID){
      const getPac = await axios.getWithCache(`${endpoints.getPacByStateId(stateID)}`,Auth.loggedIn());
      setFormData3_1((hierarchy_details_urban: { parlimentary: any;lac:any }) => ({
        ...hierarchy_details_urban,
        parlimentary: {
          ...hierarchy_details_urban.parlimentary,
          '#options': getPac.data.data,
        },
        lac: {
          ...hierarchy_details_urban.lac,
          '#options': [],
        },
      }))
      setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
        ...hierarchyDetailsUrbanFormState,
        lac: {
          ...hierarchyDetailsUrbanFormState.lac,
          value: '',
          id: '',
        }
      }))
    }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
    }
  }

  const getLAC = async (pacID: any) => {
    try {
      if(pacID){
      const getLac = await axios.getWithCache(`${endpoints.getLacByPac(pacID)}`,Auth.loggedIn());
      if (facilityDetailsFormState.rural_urban.value.toLowerCase() === 'urban') {
        setFormData3_1((hierarchy_details_urban: { lac: any }) => ({
          ...hierarchy_details_urban,
          lac: {
            ...hierarchy_details_urban.lac,
            '#options': getLac.data.data,
          }
        }));
        setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
          ...hierarchyDetailsUrbanFormState,
          lac: {
            ...hierarchyDetailsUrbanFormState.lac,
            value: '',
            id: '',
          }
        }));
      }
      else {
        setFormData3_2((hierarchy_details_rural: { lac: any }) => ({
          ...hierarchy_details_rural,
          lac: {
            ...hierarchy_details_rural.lac,
            '#options': getLac.data.data,
          }
        }));
        setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
          ...hierarchyDetailsRuralFormState,
          lac: {
            ...hierarchyDetailsRuralFormState.lac,
            value: '',
            id: '',
          }
        }))
      }}
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
    }
  }

  const handleFacilityDetailsFormChange = (value: any, key: string, id: any, code: any) => {
    setFacilityDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
    if(key==='hpr_id'){
      setHfrIdError(false);
    }
    setFacilityDetailsChange(true);
  };
  //Form 2 handler
  const handleEnrollmentDetailsFormChange = (value: string | boolean, key: string, id: any) => {
    setEnrollmentDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id
      },
    }));
    setEffectiveDateChange(true)
  };

  //Form 3 handler
  const handleHierarchyDetailsFormChange = (value: string | boolean, key: string, id: any,option?:any,code?:any) => {

    if (facilityDetailsFormState.rural_urban.value === 'Rural') {
      setHierarchyDetailsRuralFormState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id: id,
          code:code
        },
      }));
    } else {
      setHierarchyDetailsUrbanFormState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id: id,
         code:code

        },
      }));

    }
    setHierarchyDetailsChange(true)
  };

  const handleInputChange=_.debounce((value:string, key:string)=>{
    if(key === 'ulb'){
      setUlbInputText(value.trim());
    }
  },500);

  //form 4 handler
  const handleLocationDetailsFormChange = (value: string | boolean, key: string, id: any) => {
    setLocationDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
      },
    }));

    if (key === 'lattitude' || key === 'longitude') {
      setlatlngValidated(false);
    }
  };
  const handleLocationDetailsError = useCallback((value: any, key: string) => {
    setLocationDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        ...value
      },
    }));
  }, []);

  //form5


  //ABDM details
  const abdmOnClick = () => {
    const fetchABDMLocal = async () => {
      try {
        const facilityId = hfrIdCheck;
        const response = await axios.get(`${endpoints.getABDMDetails(facilityId)}`,Auth.loggedIn());
        if (response.status === 200) {
          const facilities = response?.data.data;
          if (facilities.length > 0) {
            setABDMLocalData(facilities[0]);
            setABDMClickVerify(true);
          }
        }
        else {
          errorLogger(`Error fetching ABDM details:${response.status}`,"Health Facility Update")

        }
      }
      catch (error: any) {
        if (axios.isAxiosError(error)) {
          errorLogger(`Axios error:${error.message}`,"Health Facility Update")
          if (error.response) {
            errorLogger(`Error response:${error.response.status}`,"Health Facility Update")
            if (error.response.status === 500) {
              errorLogger(`error.response.data.data:${error.response.data.data}`,"Health Facility Update")
            }
          }
        } else {
          errorLogger(error,"Health Facility Update")
        }
      }
    }
    fetchABDMLocal();
  }
  const closeABDMLocalModal = () => {
    setABDMClickVerify(false);
  }
 
  const checkMatchingScore = () => {
    if (facilityDetailsFormState.hpr_id.value) {
      const enteredFCName = facilityDetailsFormState.facility_name.value;
      const ABDMFCName = abdmFacilityData.facilityName;
      const result = calculateSimilarity(enteredFCName, ABDMFCName)
      setMatchingScore(result);
      if (result < 70) {
       //setClickVerify(false);
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          facility_name: {
            ...facilityDetailsFormState.facility_name,
            message: 'Matching score <70 %.',
            isError: true,
          },
        }));
         //setabdmFacilityData({});
      }
      else {
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          hpr_id: {
            ...facilityDetailsFormState.hpr_id,
            message: '',
            isError: false,
            verifiedDetails: 'verified',
          },
        }));
      }
    }
  }

  useEffect(() => {
    if (facilityDetailsFormState.facility_name.value) {
      checkMatchingScore();

    }
  }, [abdmFacilityData])

  const showVerifyModal = async (facilityId:string) =>{
    try{
      const response = await axios.post(`${endpoints.verifyHFR}`, { facilityId },Auth.loggedInWithJSON());
      if (response.status === 200) {
        const facilities = response?.data.data?.facilities;
        if (facilities.length > 0) {
          const facility = facilities[0];
          if (facility.stateLGDCode === `${stateCode}` && facility.districtLGDCode === `${distCode}`) {
            setabdmFacilityData(facility);
            setClickVerify(true);
            setVerify(true);
            setHfrIdError(false);
          }
          else {
            setClickVerify(false);
            setVerify(false);
            setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
              ...facilityDetailsFormState,
              hpr_id: {
                ...facilityDetailsFormState.hpr_id,
                message: 'State code or District code is incorrect',
                isError: true,
              },
            }));
            setHfrIdError(true);
          }
        }
        else {
          setVerify(false);
          setClickVerify(false);
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            hpr_id: {
              ...facilityDetailsFormState.hpr_id,
              message: 'Enter Valid HFR Id',
              isError: true,
            },
          }));

        }
      }
      else {
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          hpr_id: {
            ...facilityDetailsFormState.hpr_id,
            message: 'Enter Valid HFR Id',
            isError: true,
          },
        }));
        setClickVerify(false);
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error)
    }
  }


  const onClickVerify = async () => {
    try {
      if (facilityDetailsFormState?.hpr_id?.value) {
        const facilityId = facilityDetailsFormState?.hpr_id?.value;
        const facilityNameC = facilityDetailsFormState?.facility_name?.value;
        const ifHfrExistinRCH = await axios.get(`${endpoints.checkFacilityExistInFM(facilityId)}`,Auth.loggedIn());
        if (facilityDetailsFormState?.hpr_id?.value !== hfrIdCheck) {
          if(ifHfrExistinRCH.status === 200)  {
            if (ifHfrExistinRCH?.data?.data?.[0]?.check_hfr_in_facility_master === true) {
              setVerify(false);
              setClickVerify(false);
              setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
                ...facilityDetailsFormState,
                hpr_id: {
                  ...facilityDetailsFormState.hpr_id,
                  message: 'The HFR ID is already associted with another facility.',
                  isError: true,
                },
              }));
            }else{
              showVerifyModal(facilityId);
            }
          }else {
            errorLogger(`Error while checking HFR exist or not:${ifHfrExistinRCH.status}`,"Health Facility Update")
          }
        }
        else{
          showVerifyModal(facilityId);
        }
        if (facilityDetailsFormState.facility_name.value.length === 0) {
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            facility_name: {
              ...facilityDetailsFormState.facility_name,
              message: 'Health Facility Name cannot be kept blank.',
              isError: true,
            },
          }));
        }
        if (facilityDetailsFormState.facility_name.value.length > 500) {
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            facility_name: {
              ...facilityDetailsFormState.facility_name,
              message: 'Health Facility Name cannot more than 500 letters.',
              isError: true,
            },
          }));
        }
        if (facilityDetailsFormState?.hpr_id?.value === '000000000000') {
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            hpr_id: {
              ...facilityDetailsFormState.hpr_id,
              message: 'Invalid HFR id.',
              isError: true,
            },
          }));
        }
        if (facilityDetailsFormState?.hpr_id?.value.length !== 12) {
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            hpr_id: {
              ...facilityDetailsFormState.hpr_id,
              message: 'HFR ID must be 12 digits',
              isError: true,
            },
          }));
        }
      }
    } catch (error: any) {
      setVerify(false);


      if (axios?.isAxiosError(error)) {
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          hpr_id: {
            ...facilityDetailsFormState.hpr_id,
            message: 'Enter Valid HFR Id',
            isError: true,
          },
        }));

        if (error.response) {
          errorLogger(error.response,"Health Facility Update");
          if (error.response.status === 500) {
            errorLogger(error.response.data.data,"Health Facility Update")
          }
        }
      } 
    }
  }

  let FacilityDetailsFromABDM:any;
  const verifyHFRID = async (facilityId: string) => {
    try {
      const response = await axios.post(`${endpoints.verifyHFR}`, { facilityId }, Auth.loggedInWithJSON());

      if (response.status === 200) {

        const facilities = response?.data.data?.facilities;
        if (facilities.length > 0) {
          const facility = facilities[0];
          if (facility.stateLGDCode === `${stateCode}` && facility.districtLGDCode === `${distCode}`) {
            setHfrIdError(false);
            FacilityDetailsFromABDM = facility;
            return false;
          }
          else {
            setHfrIdError(true);
            return true;
          }

        }
        else {
          return false;
        }
      }
    }
    catch (error: any) {
      return false;
    }

  }
  const closeVerifyModal = () => {
    setClickVerify(false);
    setABDMdata(abdmFacilityData);
    setVerify(true);
  }
  //enabling status dropdown
  useEffect(()=>{
    if(verify===true){
      setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
        ...enrollmentDetailsFormState,
        status: {
          ...enrollmentDetailsFormState.status,
          value:'Functional',
          id:'da1624e9-9ea0-4960-9634-c5a782850288'
        }
      }));
      setFormData2((facility_enrollmentdetails: { status: any }) => ({
        ...facility_enrollmentdetails,
        status: {
          ...facility_enrollmentdetails.status,
          '#required': true,
          '#isDisabled':false
        }
      }));

    }
  },[verify])

  useEffect(()=>{
    if(!facilityDetailsFormState.hpr_id.value){
      setFormData2((facility_enrollmentdetails: { status: any }) => ({
        ...facility_enrollmentdetails,
        status: {
          ...facility_enrollmentdetails.status,
          '#isDisabled': true,
          '#required':false
        }
      }));
      setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
        ...enrollmentDetailsFormState,
        status: {
          ...enrollmentDetailsFormState.status,
          value: 'Inactive',
          id: 'd1b444b2-7735-4a35-8ba1-b8fbed0a0810',
        }
      }));
    }
    if(facilityDetailsFormState.hpr_id.value && facilityDetailsFormState.hpr_id.value === hfrIdCheck){
      setVerify(true);
    }
  },[facilityDetailsFormState.hpr_id.value])

  // Google Map - start
  // useEffect(() => {
  //   if (locationDetailsFormState.lattitude.value && locationDetailsFormState.longitude.value && !latlngValidated) {
  //     validateLocation(locationDetailsFormState.lattitude.value, locationDetailsFormState.longitude.value)
  //   }
  // }, [locationDetailsFormState.lattitude.value, locationDetailsFormState.longitude.value, latlngValidated])

  // const validateLocation = (lattitude: any, longitude: any) => {
  //   axios.get(`${config.googleMapApiUrl}?latlng=${parseFloat(lattitude)},${parseFloat(longitude)}&key=${config.googleMapToken}`)
  //     .then((res: any) => {
  //       if (res.data && res.data.status === 'OK') {
  //         const response = res.data.results && res.data.results[0];
  //         if (response) {
  //           setlatlngValidated(true);
  //         }
  //       } else {
  //         setlatlngValidated(false);
  //       }
  //     }).catch((error:any) => {
  //     });
  // }
  // const setLatLog = (lattitude: any, longitude: any) => {
  //   if (lattitude && longitude && locationDetailsFormState.lattitude.value != lattitude || locationDetailsFormState.longitude.value != longitude) {
  //     setLocationDetailsFormState((locationDetailsFormState: any) => ({
  //       ...locationDetailsFormState,
  //       lattitude: {
  //         ...locationDetailsFormState.lattitude,
  //         value: lattitude,
  //       },
  //       longitude: {
  //         ...locationDetailsFormState.longitude,
  //         value: longitude,
  //       }
  //     }));
  //     getAddressUsingLatLong(lattitude, longitude);
  //   }
  // }
  // Google Map - end

  // Format Coverage data -start

  const onClickNext = (overwriteFacName: any = false) => {
    if(overwriteFacName) {
      setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
        ...facilityDetailsFormState,
          facility_name: {
          ...facilityDetailsFormState.facility_name,
          value: abdmFacilityData.facilityName,
          isError: false,
          message: ''
          },
          hpr_id: {
            ...facilityDetailsFormState.hpr_id,
            isError: false,
            message: '',
            verifiedDetails: 'verified',
          }
        }
      ))
    }
    closeVerifyModal()
  }

  const handleRuralFacilityUnlink = (unlinkedruralfacilities: any) => {
    const keys = unlinkedruralfacilities.map((i: any) => i.id);
    const filteredData = unlinkedruralfacilities && unlinkedruralfacilities.length > 0 && linkedFacilitiesRural.filter((item: any) => !keys.includes(item.facility_id));
    setLinkedFacilitiesRural(filteredData);
  }
  const handleUrbanFacilityUnlink = (unlinkedUrbanfacilities: any) => {
    const keys = unlinkedUrbanfacilities.map((i: any) => i.id);
    const filteredData = unlinkedUrbanfacilities && unlinkedUrbanfacilities.length > 0 && linkedFacilitiesUrban.filter((item: any) => !keys.includes(item.facility_id));
    setLinkedFacilitiesUrban(filteredData);
  }


  const handleVillageUnlink = (unlinkedruralfacilities: any) => {
    const keys = unlinkedruralfacilities.map((i: any) => i.id);
    const filteredData = unlinkedruralfacilities && unlinkedruralfacilities.length > 0 && linkedVillageRural.filter((item: any) => !keys.includes(item.village_id));
    setLinkedVillageRural(filteredData);
  }

  const handleGramPanchayatUnlink = (unlinkedruralfacilities: any) => {
    const keys = unlinkedruralfacilities.map((i: any) => i.id);
    const filteredData = unlinkedruralfacilities && unlinkedruralfacilities.length > 0 && linkedGramPanchayatRural.filter((item: any) => !keys.includes(item.gram_panchayat_id));
    setLinkedGramPanchayatRural(filteredData);
  }

  const handleWardUnlink = (unlinkedruralfacilities: any) => {
    const keys = unlinkedruralfacilities.map((i: any) => i.id);
    const filteredData = unlinkedruralfacilities && unlinkedruralfacilities.length > 0 && linkedWardRural.filter((item: any) => !keys.includes(item.ward_id));
    setLinkedWardRural(filteredData);
  }

  const formatLinkedFacility = (data: any, type: string) => {
    if (type === 'linked-facility') {
      return data.map((item: any) => ({
        id: item.facility_id,
        name: item.facility_name,
        code: item.facility_code,
      }));
    } else if (type === 'village') {
      return data.map((item: any) => ({
        id: item.village_id,
        name: item.village_name,
        code: item.village_code,
      }));
    }
    else if (type === 'gram_panchayat') {
      return data.map((item: any) => ({
        id: item.gram_panchayat_id,
        name: item.gram_panchayat_name,
        code: item.gram_panchayat_code,
      }));
    }
    else if (type === 'ward') {
      return data.map((item: any) => ({
        id: item.ward_id,
        name: item.ward_name,
        code: item.ward_code,
      }));
    }
    else {
      return [];
    }



  }

  const formatSelectedFacilityModel = (data: any, type: string) => {
    if (type === 'facilityRural') {
      let facilityCoveredOptionsObject: any = {};
      const facilityCoveredOptions: any = [];
      data && data.map((e: any) => {
        facilityCoveredOptions.push(e.facility_name)
      })
      facilityCoveredOptionsObject = facilityCoveredOptions.reduce((acc: any, current: any) => {
        if (!acc[current]) {
          acc[current] = current;
        }
        return acc;
      }, {});

      return facilityCoveredOptionsObject;

    } else if (type === 'facilityUrban') {
      let facilityCoveredOptionsObject: any = {};
      const facilityCoveredOptions: any = [];
      data && data.map((e: any) => {
        facilityCoveredOptions.push(e.facility_name)
      })
      facilityCoveredOptionsObject = facilityCoveredOptions.reduce((acc: any, current: any) => {
        if (!acc[current]) {
          acc[current] = current;
        }
        return acc;
      }, {});

      return facilityCoveredOptionsObject;
    } else if (type === 'WardsUrban') {
      let urbanCoveredOptionsObject: any = {};
      const urbanCoveredOptions: any = [];
      data && data.map((e: any) => {
        urbanCoveredOptions.push(e.ward_name)
      })
      urbanCoveredOptionsObject = urbanCoveredOptions.reduce((acc: any, current: any) => {
        if (!acc[current]) {
          acc[current] = current;
        }
        return acc;
      }, {});

      return urbanCoveredOptionsObject;
    }
    else if (type === 'VillagesRuarl') {
      let villagesCoveredOptionsObject: any = {};
      const villagesCoveredOptions: any = [];
      data && data.map((e: any) => {
        villagesCoveredOptions.push(e.village_name)
      })
      villagesCoveredOptionsObject = villagesCoveredOptions.reduce((acc: any, current: any) => {
        if (!acc[current]) {
          acc[current] = current;
        }
        return acc;
      }, {});

      return villagesCoveredOptionsObject;
    }


   


  }  // Format Coverage data -end

  const updateFacilityDetails = async (payload:any, isABDMInsertRequired:boolean, hfrPresentInABDM:boolean) =>{
    try{
      const data: any = await manageHealthFacilityJson(JSON.parse(JSON.stringify(payload)), villagesPayLoad, wardsPayLoad, villagesCount, wardsCount)
      const mainPayload = data.mainPayload;
      const combinedChunks: any[] = data.combinedChunks;

      const compressedMainData = pako.gzip(JSON.stringify(mainPayload));
      const encodeCompressedMainData = await uint8ToBase64(compressedMainData);
      let response: any;
      if(isABDMInsertRequired && !hfrPresentInABDM){
        if (combinedChunks.length > 0) {
          await putDataJSON<any>(`${endpoints.updateAbdmOrRchFacility}`, {data: encodeCompressedMainData}).then(async (res:any) => {
            if (res?.data) {
              let subRes: any
              for (const value of combinedChunks) {
                try {
                  const compressedDataWithIds = value ? pako.gzip(JSON.stringify({facilityId: payload.facilityId,
                    stCode: payload.stCode, ...value})) : null;
                  const encodeCompressedDataWithIds = compressedDataWithIds ? await uint8ToBase64(compressedDataWithIds) : '';
                  subRes = await putDataJSON<any>(`${endpoints.updateAbdmOrRchFacilityWithMoreEntityIds}`, {data: encodeCompressedDataWithIds})
                } catch (err) {
                  setLoading(false);
                  toast.warning("Some coverage details could not be saved, try again.", {
                    position: "top-center"
                  });
                }
              }
              response = subRes;
            } else {
              response = res;
            }
          });
        } else {
          response = await putDataJSON<any>(`${endpoints.updateAbdmOrRchFacility}`, {data: encodeCompressedMainData}); //insertABDM-updateFacilityMaster
        }
      }else{
        if (combinedChunks.length > 0) {
          await putDataJSON<any>(`${endpoints.updateAbdmOrRchFacility}`, {data: encodeCompressedMainData}).then(async (res:any) => {
            if (res?.data) {
              response = res;
              let subRes: any
              for (const value of combinedChunks) {
                try {
                  const compressedDataWithIds = value ? pako.gzip(JSON.stringify({facilityId: payload.facilityId,
                    stCode: payload.stCode, ...value})) : null;
                  const encodeCompressedDataWithIds = compressedDataWithIds ? await uint8ToBase64(compressedDataWithIds) : '';
                  subRes = await putDataJSON<any>(`${endpoints.updateAbdmOrRchFacilityWithMoreEntityIds}`, {data: encodeCompressedDataWithIds})
                } catch (err) {
                  setLoading(false);
                  toast.warning("Some coverage details could not be saved, try again.", {
                    position: "top-center"
                  });
                }
              }
              response = subRes ? subRes : res;
            } else {
              response = res
            }
          }); //updateABDM-updateFacilityMaster
        } else {
          response = await putDataJSON<any>(`${endpoints.updateAbdmOrRchFacility}`, {data: encodeCompressedMainData}); //updateABDM-updateFacilityMaster
        }
      }
      if (response?.data) {
        toast.success((LogedinUserDetails && LogedinUserDetails?.usertype_name === USER_TYPES.DISTRICT_LEVEL_USER && (roleData == roleType.both || roleData == roleType.only_administrator)) ? "Request has been sent for Approval" : "Records have been successfully corrected & saved", {
          position: "top-center"
        });
      } else {
        toast.error("Records could not be corrected.", {
          position: "top-center"
        });
      }
      navigate(`/health-facility`);
      clearMapStore();
      setLoading(false);
    }
    catch (error) {
      setLoading(false);
      toast.error("Records could not be corrected.", {
        position: "top-center"
      });
    }
  }


  //Error handling
  const isError: boolean[] = [];
  //Update
  const onHandleSave = async () => {
    setLoading(true);
    let similarityData: number;
    let hfrIdVerify:boolean=false;
    if(facilityDetailsFormState.hpr_id.value === hfrIdCheck && hfrIdCheck?.length===12 &&!hfrIdError ){
      hfrIdVerify=await verifyHFRID(hfrIdCheck)?true:false;
    }
    const isError: boolean[] = [];
    if(facilityDetailsFormState.facility_name.value){
      const data = {
        stateCode:stateCode,
        distCode:distCode,
        facilityName: facilityDetailsFormState.facility_name.value,
      }
      const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data))
      const response=await axios.post(`${endpoints.checkSimilarity}`, { data: encodedPayload }, Auth.loggedIn());
      const data1=response.data?.data[0];
      similarityData=data1?.similarity_percent;
    }
    {//Facility Form State Errror Handling
      const FacilityDetailsFormStateError = {
        ...facilityDetailsFormState
      };
      let isFacilityFormError = false;
      Object.keys(FacilityDetailsFormStateError).map((item) => {
        if (item === 'facility_name') {
          if (!FacilityDetailsFormStateError.facility_name.value) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.facility_name.isError = true;
            FacilityDetailsFormStateError.facility_name.message = 'Enter facility name to continue';
          }
          else if (!/^[a-zA-Z0-9\s.,\-@#$%&*!+?():'"/]+$/.test(facilityDetailsFormState.facility_name.value)) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.facility_name.isError = true;
            FacilityDetailsFormStateError.facility_name.message = 'Health Facility Name cannot have special characters';
          }
          else if (facilityDetailsFormState.facility_name.value.length > 500) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.facility_name.isError = true;
            FacilityDetailsFormStateError.facility_name.message = 'Health Facility Name length should be limited to 500';
          }
          // else if (facilityDetailsFormState.facility_name.value && similarityData && facilityNameCheck!==facilityDetailsFormState.facility_name.value) {
          //     isFacilityFormError = true;
          //     FacilityDetailsFormStateError.facility_name.isError = true;
          //     FacilityDetailsFormStateError.facility_name.message = `The Health Facility Name already exists with matching score of ${Math.floor(similarityData)}%. Choose a unique Health Facility Name to continue.`;  
          //  }
         else{
            FacilityDetailsFormStateError.facility_name.isError = false;            
          }
        }
        else if (item === 'rural_urban') {
          if (!FacilityDetailsFormStateError.rural_urban.value) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.rural_urban.isError = true;
            FacilityDetailsFormStateError.rural_urban.message = 'Select an input to continue.';
          }
          else {
            FacilityDetailsFormStateError.rural_urban.isError = false;
          }
        }
        else if (item === 'facility_type') {
          if (!FacilityDetailsFormStateError.facility_type.value) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.facility_type.isError = true;
            FacilityDetailsFormStateError.facility_type.message = 'Select Facility Type to continue.';
          }
          else {
            FacilityDetailsFormStateError.facility_type.isError = false;
          }
        }
        
        else if (item === 'ownership') {
          if (!FacilityDetailsFormStateError.ownership.value) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.ownership.isError = true;
            FacilityDetailsFormStateError.ownership.message = 'Select ownership from the dropdown.';
          }
          else {
            FacilityDetailsFormStateError.ownership.isError = false;
          }
        }
        else if (item === 'administrative_body') {
          if (!FacilityDetailsFormStateError.administrative_body.value && formData1?.administrative_body?.['#required']) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.administrative_body.isError = true;
            FacilityDetailsFormStateError.administrative_body.message = 'Select administrative body from the dropdown.';
          }
          else {
            FacilityDetailsFormStateError.administrative_body.isError = false;
          }
        }
        else if (item === 'central_govt_dept') {
          if (FacilityDetailsFormStateError.administrative_body.value==="Central Government"&&!FacilityDetailsFormStateError.central_govt_dept.value && formData1?.central_govt_dept?.['#required']) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.central_govt_dept.isError = true;
            FacilityDetailsFormStateError.central_govt_dept.message = 'Select Central Government Dept from the dropdown.';
          }
          else {
            FacilityDetailsFormStateError.central_govt_dept.isError = false;
          }
        }
        else if (item === 'hpr_id') {
            if(hfrIdError ||hfrIdVerify){
              isFacilityFormError = true;
              FacilityDetailsFormStateError.hpr_id.isError = true;
              FacilityDetailsFormStateError.hpr_id.message = 'State code or District code is incorrect';
            }
            else if (FacilityDetailsFormStateError.hpr_id.value && FacilityDetailsFormStateError.hpr_id.value !== hfrIdCheck) {
              if (FacilityDetailsFormStateError.hpr_id.verifiedDetails == 'not verified') {
                FacilityDetailsFormStateError.hpr_id.isError = true;
                FacilityDetailsFormStateError.hpr_id.message = 'HFR ID not yet verified.';
                FacilityDetailsFormStateError.facility_name.isError = true;
                FacilityDetailsFormStateError.facility_name.message = 'Matching score needs to be recalculated.';
                isFacilityFormError = true;
              } else {              
                FacilityDetailsFormStateError.hpr_id.isError = false;
                FacilityDetailsFormStateError.hpr_id.message = '';
                // FacilityDetailsFormStateError.facility_name.isError = false;
                // FacilityDetailsFormStateError.facility_name.message = '';
                // isFacilityFormError = true;
            } 
            }
        }   

        // else if (item === 'hpr_id') {
        //   if (FacilityDetailsFormStateError.hpr_id.value !== hfrIdCheck) {
        //     if (FacilityDetailsFormStateError.hpr_id.verifiedDetails == 'not verified') {
        //       FacilityDetailsFormStateError.hpr_id.isError = true;
        //       FacilityDetailsFormStateError.hpr_id.message = 'HFR ID not yet verified.';
        //       FacilityDetailsFormStateError.facility_name.isError = true;
        //       FacilityDetailsFormStateError.facility_name.message = 'Matching score needs to be recalculated.';
        //       isFacilityFormError = true;
        //     }
        //     else {
        //       FacilityDetailsFormStateError.hpr_id.isError = false;
        //       FacilityDetailsFormStateError.hpr_id.message = '';
        //       // FacilityDetailsFormStateError.facility_name.isError = false;
        //       // FacilityDetailsFormStateError.facility_name.message = '';
        //     }
        //   }
        // }
      })
      setFacilityDetailsFormState(FacilityDetailsFormStateError);
      isError[0] = isFacilityFormError;
    }
    {//Enrollment Form State Errror Handling
      const EnrollmentDetailsFormStateError = {
        ...enrollmentDetailsFormState
      };
      let isEnrollmentFormError = false;
      Object.keys(EnrollmentDetailsFormStateError).map((item) => {
        if (item === 'date_of_enrollment') {
          if (!EnrollmentDetailsFormStateError.date_of_enrollment.value) {
            isEnrollmentFormError = true;
            EnrollmentDetailsFormStateError.date_of_enrollment.isError = true;
            EnrollmentDetailsFormStateError.date_of_enrollment.message = 'Enter date of enrollment to continue.';
          }
          else {
            EnrollmentDetailsFormStateError.date_of_enrollment.isError = false;
          }
        }
        else if (item === 'effective_from_date') {
          if (!EnrollmentDetailsFormStateError.effective_from_date.value) {
            isEnrollmentFormError = true;
            EnrollmentDetailsFormStateError.effective_from_date.isError = true;
            EnrollmentDetailsFormStateError.effective_from_date.message = 'Enter effective from date to continue.';
          }
          else {
            EnrollmentDetailsFormStateError.effective_from_date.isError = false;
          }
        }
        else if (item === 'status') {
          if (!EnrollmentDetailsFormStateError.status.value) {
            isEnrollmentFormError = true;
            EnrollmentDetailsFormStateError.status.isError = true;
            EnrollmentDetailsFormStateError.status.message = 'Select state from the dropdown';
          }
          else {
            EnrollmentDetailsFormStateError.status.isError = false;
          }
        }
        else if (item === 'sanctionedbed_count') {
          if (!EnrollmentDetailsFormStateError.sanctionedbed_count.value) {
            EnrollmentDetailsFormStateError.sanctionedbed_count.isError = false;
            EnrollmentDetailsFormStateError.sanctionedbed_count.message = '';
          }
          else if (EnrollmentDetailsFormStateError.sanctionedbed_count.value.length > 4) {
            isEnrollmentFormError = true;
            EnrollmentDetailsFormStateError.sanctionedbed_count.isError = true;
            EnrollmentDetailsFormStateError.sanctionedbed_count.message = 'Sanctioned bed count should be limited to 4 digits';
          } else {
            EnrollmentDetailsFormStateError.sanctionedbed_count.isError = false;
          }
        }
        else if (item === 'functionalbed_count') {
          if (!EnrollmentDetailsFormStateError.functionalbed_count.value) {
            EnrollmentDetailsFormStateError.functionalbed_count.isError = false;
            EnrollmentDetailsFormStateError.functionalbed_count.message = '';
          }
          else if (EnrollmentDetailsFormStateError.functionalbed_count.value.length > 4) {
            isEnrollmentFormError = true;
            EnrollmentDetailsFormStateError.functionalbed_count.isError = true;
            EnrollmentDetailsFormStateError.functionalbed_count.message = 'functional bed count should be limited to 4 digits';
          }
          else if (parseInt(EnrollmentDetailsFormStateError.functionalbed_count.value) > parseInt(EnrollmentDetailsFormStateError.sanctionedbed_count.value)) {
            isEnrollmentFormError = true;
            EnrollmentDetailsFormStateError.functionalbed_count.isError = true;
            EnrollmentDetailsFormStateError.functionalbed_count.message = 'Functional bed count should be less than or equal to sanctioned bed count';
          } else {
            EnrollmentDetailsFormStateError.functionalbed_count.isError = false;
          }
        }
      })
      setEnrollmentDetailsFormState(EnrollmentDetailsFormStateError);
      isError[1] = isEnrollmentFormError;
    }
    {//Hierarchy Form State Errror Handling
      if (facilityDetailsFormState.rural_urban.value === 'Rural') {
        const HierarchyDetailsRuralFormStateError = {
          ...hierarchyDetailsRuralFormState
        };
        let isHierarchyRuralFormError = false;
        Object.keys(HierarchyDetailsRuralFormStateError).map((item) => {
          if (item === 'state') {
            if (!HierarchyDetailsRuralFormStateError.state.value) {
              isHierarchyRuralFormError = true;
              HierarchyDetailsRuralFormStateError.state.isError = true;
              HierarchyDetailsRuralFormStateError.state.message = 'Select state from the dropdown';
            }
            else {
              HierarchyDetailsRuralFormStateError.state.isError = false;
            }
          }
          else if (item === 'district') {
            if (!HierarchyDetailsRuralFormStateError.district.value) {
              isHierarchyRuralFormError = true;
              HierarchyDetailsRuralFormStateError.district.isError = true;
              HierarchyDetailsRuralFormStateError.district.message = 'Select District from the dropdown';
            }
            else {
              HierarchyDetailsRuralFormStateError.district.isError = false;
            }
          }
          else if (item === 'sub_district') {
            if (!HierarchyDetailsRuralFormStateError.sub_district.value && formData3_2.sub_district?.['#required']) {
              isHierarchyRuralFormError = true;
              HierarchyDetailsRuralFormStateError.sub_district.isError = true;
              HierarchyDetailsRuralFormStateError.sub_district.message = 'Select sub district from the dropdown.';
            }
            else {
              HierarchyDetailsRuralFormStateError.sub_district.isError = false;
            }
          }
          else if (item === 'block') {
            if (!HierarchyDetailsRuralFormStateError.block.value && formData3_2.block?.['#required'] === true) {
              isHierarchyRuralFormError = true;
              HierarchyDetailsRuralFormStateError.block.isError = true;
              HierarchyDetailsRuralFormStateError.block.message = 'Select Block from the dropdown.';
            }
            else {
              HierarchyDetailsRuralFormStateError.block.isError = false;
            }
          }
          else if (item === 'village') {
            if (!HierarchyDetailsRuralFormStateError.village.value && formData3_2.village?.['#required'] === true  && formData3_2.village?.['#isVisible'] === true) {
              isHierarchyRuralFormError = true;
              HierarchyDetailsRuralFormStateError.village.isError = true;
              HierarchyDetailsRuralFormStateError.village.message = 'Select Village from the dropdown';
            }
            else {
              hierarchyDetailsRuralFormState.village.isError = false;
            }
          }
          else if (item === 'gram_panchayat') {
            if (!HierarchyDetailsRuralFormStateError.gram_panchayat.value && formData3_2.gram_panchayat?.['#required'] === true && formData3_2.gram_panchayat?.['#isVisible'] === true) {
              isHierarchyRuralFormError = true;
              HierarchyDetailsRuralFormStateError.gram_panchayat.isError = true;
              HierarchyDetailsRuralFormStateError.gram_panchayat.message = 'Select Gram Panchayat / ADC Village from the dropdown';
            }
            else {
              hierarchyDetailsRuralFormState.gram_panchayat.isError = false;
            }
          }
        })
        setHierarchyDetailsRuralFormState(HierarchyDetailsRuralFormStateError);
        isError[2] = isHierarchyRuralFormError;
      }
      else {
        const HierarchyDetailsUrbanFormStateError = {
          ...hierarchyDetailsUrbanFormState
        };
        let isHierarchyUrbanFormError = false;
        Object.keys(HierarchyDetailsUrbanFormStateError).map((item) => {
          if (item === 'district') {
            if (!HierarchyDetailsUrbanFormStateError.district.value) {
              isHierarchyUrbanFormError = true;
              HierarchyDetailsUrbanFormStateError.district.isError = true;
              HierarchyDetailsUrbanFormStateError.district.message = 'Select District from the dropdown.';
            }
            else {
              HierarchyDetailsUrbanFormStateError.district.isError = false;
            }
          }
          else if (item === 'sub_district') {
            if (!HierarchyDetailsUrbanFormStateError.sub_district.value && formData3_1.sub_district?.['#required']) {
              isHierarchyUrbanFormError = true;
              HierarchyDetailsUrbanFormStateError.sub_district.isError = true;
              HierarchyDetailsUrbanFormStateError.sub_district.message = 'Select sub district from the dropdown.';
            }
            else {
              HierarchyDetailsUrbanFormStateError.sub_district.isError = false;
            }
          }
          else if (item === 'state') {
            if (!HierarchyDetailsUrbanFormStateError.state.value) {
              isHierarchyUrbanFormError = true;
              HierarchyDetailsUrbanFormStateError.state.isError = true;
              HierarchyDetailsUrbanFormStateError.state.message = 'Select state from the dropdown.';
            }
            else {
              HierarchyDetailsUrbanFormStateError.state.isError = false;
            }
          }
          else if (item === 'ulb') {
            if (!HierarchyDetailsUrbanFormStateError.ulb.value) {
              isHierarchyUrbanFormError = true;
              HierarchyDetailsUrbanFormStateError.ulb.isError = true;
              HierarchyDetailsUrbanFormStateError.ulb.message = 'Select ULB from the dropdown.';
            }
            else {
              HierarchyDetailsUrbanFormStateError.ulb.isError = false;
            }
          }
          else if (item === 'ward') {
            if (!HierarchyDetailsUrbanFormStateError.ward.value) {
              isHierarchyUrbanFormError = true;
              HierarchyDetailsUrbanFormStateError.ward.isError = true;
              HierarchyDetailsUrbanFormStateError.ward.message = 'Select Ward from the dropdown.';
            }
            else {
              hierarchyDetailsUrbanFormState.ward.isError = false;
            }
          }
        })
        setHierarchyDetailsUrbanFormState(HierarchyDetailsUrbanFormStateError);
        isError[3] = isHierarchyUrbanFormError;
      }
    }
    {//Location Form State Errror Handling
      const LocationDetailsFormStateError = {
        ...locationDetailsFormState
      };
      let isLocationFormError = false;
      Object.keys(LocationDetailsFormStateError).map((item) => {
        if (item === 'address') {
          if (!LocationDetailsFormStateError.address.value) {
            isLocationFormError = true;
            LocationDetailsFormStateError.address.isError = true;
            LocationDetailsFormStateError.address.message = 'Enter address to continue.';
          }
          else {
            LocationDetailsFormStateError.address.isError = false;
          }
        }
        else if (item === 'pincode') {
          if (!LocationDetailsFormStateError.pincode.value) {
            isLocationFormError = true;
            LocationDetailsFormStateError.pincode.isError = true;
            LocationDetailsFormStateError.pincode.message = 'Enter valid pincode to continue.';
          }
          else if (!/^\d{6}$/.test(LocationDetailsFormStateError.pincode.value)) {
            isLocationFormError = true;
            LocationDetailsFormStateError.pincode.isError = true;
            LocationDetailsFormStateError.pincode.message = 'Enter valid pincode to continue.';
          }
          else if (LocationDetailsFormStateError.pincode.value.length !== 6) {
            isLocationFormError = true;
            LocationDetailsFormStateError.pincode.isError = true;
            LocationDetailsFormStateError.pincode.message = 'Pincode should be in 6 digits.';
          }
          else {
            LocationDetailsFormStateError.pincode.isError = false;
          }
        }
        else if (item === 'longitude') {
          if (!LocationDetailsFormStateError.longitude.value) {
            isLocationFormError = true;
            LocationDetailsFormStateError.longitude.isError = true;
            LocationDetailsFormStateError.longitude.message = 'Enter valid longitude to continue.';
          }
          else if (!/^-?\d{1,3}\.\d+$/.test(LocationDetailsFormStateError.longitude.value) ||
            parseFloat(LocationDetailsFormStateError.longitude.value) < -180 ||
            parseFloat(LocationDetailsFormStateError.longitude.value) > 180) {
            isLocationFormError = true;
            LocationDetailsFormStateError.longitude.isError = true;
            LocationDetailsFormStateError.longitude.message = 'Enter valid longitude to continue.';
          }
          else {
            LocationDetailsFormStateError.longitude.isError = false;
          }
        }
        else if (item === 'lattitude') {
          if (!LocationDetailsFormStateError.lattitude.value) {
            isLocationFormError = true;
            LocationDetailsFormStateError.lattitude.isError = true;
            LocationDetailsFormStateError.lattitude.message = 'Enter valid lattitude to continue.';
          }
          else if (!/^-?\d{1,3}\.\d+$/.test(LocationDetailsFormStateError.lattitude.value) ||
            parseFloat(LocationDetailsFormStateError.lattitude.value) < -90 ||
            parseFloat(LocationDetailsFormStateError.lattitude.value) > 90) {
            isLocationFormError = true;
            LocationDetailsFormStateError.lattitude.isError = true;
            LocationDetailsFormStateError.lattitude.message = 'Enter valid latitude to continue.'
          }
          else {
            LocationDetailsFormStateError.lattitude.isError = false;
          }
        }
      });
      // try {
      //   const promise1 = await axios.get(`${config.googleMapApiUrl}?latlng=${parseFloat(LocationDetailsFormStateError.lattitude.value)},${parseFloat(LocationDetailsFormStateError.longitude.value)}&key=${config.googleMapToken}`);
      //   const promise2 = await axios.get(`${config.googleMapApiUrl}?address=${LocationDetailsFormStateError.pincode.value}&key=${config.googleMapToken}`);
      //   const facilityFormState = facilityDetailsFormState.rural_urban.value === 'Rural' ? hierarchyDetailsRuralFormState : hierarchyDetailsUrbanFormState
      //   const res = await Promise.all([promise1, promise2]);
      //   if(res[0].data && res[0].data.status === 'OK') {
      //     const response1 = res[0].data.results && res[0].data.results[0];
      //     const { formatted_address, address_components } = response1;
      //     if(formatted_address && !formatted_address.toLocaleLowerCase().includes(facilityFormState.state.value.split('-')[0].toLocaleLowerCase())) {
      //       isLocationFormError = true;
      //       LocationDetailsFormStateError.longitude.isError = true;
      //       LocationDetailsFormStateError.longitude.message = 'Longitude is not within state range';
      //       LocationDetailsFormStateError.lattitude.isError = true;
      //       LocationDetailsFormStateError.lattitude.message = 'Lattitude is not within state range';
      //       // handleIslocationValidated(true);
      //       }
      //     // if(address_components && address_components.length > 0) {
      //     //   address_components.forEach((i:any )=> {
      //     //     if(i.types.includes("postal_code") && i.long_name !=  LocationDetailsFormStateError.pincode.value) {
      //     //       isLocationFormError = true;
      //     //       LocationDetailsFormStateError.pincode.isError = true;
      //     //       LocationDetailsFormStateError.pincode.message = 'Pincode is not matching with Lattitude and Longitude';
      //     //     }
      //     // });
      //     // }
      //   }
      //   if(res[1].data && res[1].data.status === 'OK') {
      //     const response2 = res[1].data.results && res[1].data.results[0];
      //     const { formatted_address} = response2;
      //     if(formatted_address && !formatted_address.toLocaleLowerCase().includes(facilityFormState.state.value.split('-')[0].toLocaleLowerCase())) {
      //       isLocationFormError = true;
      //       LocationDetailsFormStateError.pincode.isError = true;
      //       LocationDetailsFormStateError.pincode.message = 'Pincode is not within state range';
      //       }
      //   }
      //   if(res[1].data && res[1].data.status ==='ZERO_RESULTS') {
      //     isLocationFormError = true;
      //     LocationDetailsFormStateError.pincode.isError = true;
      //     LocationDetailsFormStateError.pincode.message = 'Pincode is not within state range or invalid pincode';
      //   }
      // } catch(error) {
      //   
      // }
      setLocationDetailsFormState(LocationDetailsFormStateError);
      isError[4] = isLocationFormError;

      if (!isLocationFormError && enableArcGISMap!=='OFF') {
        if (!facilityGeoMap.mapServicesDown) {
        if (!geometryEngine.contains(facilityGeoMap.distFenceGeometry, facilityGeoMap.mapPointer)) {
          toast.error("lattitude, longitude and address is not within district range", {
            position: "top-center",
          });

          return;
        }

        if (facilityGeoMap.isManualLatLong) {
          toast.warning("lattitude, longitude is upadted manually, please locate it on map to proceed.", {
            position: "top-center",
          });

          return;
        }
      }
      }
    }
    {//coverage validations
      // const listOfMandatoryFacilityType = ['24*7 AAM-PHC','AAM-PHC','PHC - Non-functional as AAM','24*7 PHC Non-functional as AAM','24*7 PHC/Polyclinic','Non-FRU CHC','FRU CHC'];
      let isCoverageError = false;
      if(HBSDSelected){
        let isCoverageRuralError = false;
        if(isGrampanchayat){
          if (linkedGramPanchayatRural.length === 0 && gramPanchayatCount > 0 && linkedWardRural.length === 0 && wardsCount > 0) {
            setIslinkedGramPanchayatRuralError(true);
            setErrorMessageCovLinkGramPanchayat('Select Gram Panchayats / ADC Villages from the dropdown.');
            setIslinkedWardRuralError(true);
            setErrorMessageCovLinkWard('Select wards from the dropdown.');
            isCoverageRuralError = true;
          }
          else if (linkedGramPanchayatRural.length === 0 && gramPanchayatCount === 0 && linkedWardRural.length === 0 && wardsCount > 0) {
            setIslinkedGramPanchayatRuralError(true);
            setErrorMessageCovLinkWard('Select wards from the dropdown.');
            isCoverageRuralError = true;
          }
          else if (linkedGramPanchayatRural.length === 0 && gramPanchayatCount > 0 && linkedWardRural.length === 0 && wardsCount === 0) {
            setIslinkedGramPanchayatRuralError(true);
            setErrorMessageCovLinkGramPanchayat('Select Gram Panchayats / ADC Villages from the dropdown.');
            isCoverageRuralError = true;
          }
          else {
            setIslinkedGramPanchayatRuralError(false);
            setIslinkedWardRuralError(false);
          }
          isCoverageError=isCoverageRuralError
        }
        else{
          if (linkedVillageRural.length === 0 && villagesCount > 0 && linkedWardRural.length === 0 && wardsCount > 0) {
            setIslinkedVillageRuralError(true);
            setErrorMessageCovLinkVillages('Select villages from the dropdown.');
            setIslinkedWardRuralError(true);
            setErrorMessageCovLinkWard('Select wards from the dropdown.');
            isCoverageRuralError = true;
          }
          else if (linkedVillageRural.length === 0 && villagesCount === 0 && linkedWardRural.length === 0 && wardsCount > 0) {
            setIslinkedWardRuralError(true);
            setErrorMessageCovLinkWard('Select wards from the dropdown.');
            isCoverageRuralError = true;
          }
          else if (linkedVillageRural.length === 0 && villagesCount > 0 && linkedWardRural.length === 0 && wardsCount === 0) {
            setIslinkedVillageRuralError(true);
            setErrorMessageCovLinkVillages('Select villages from the dropdown.');
            isCoverageRuralError = true;
          }
          else {
            setIslinkedVillageRuralError(false);
            setIslinkedWardRuralError(false);
          }
          isCoverageError=isCoverageRuralError
        }
       
      }
      else{
      if (facilityDetailsFormState.rural_urban.value === 'Rural') {
        let isCoverageRuralError = false;
        // if ((linkedFacilitiesCount>0) && (linkedFacilitiesRural.length === 0)&&(listOfMandatoryFacilityType.includes(facilityDetailsFormState.facility_type.value))) {
        //   setIslinkedFacilitiesRuralError(false);
        //   setErrorMessageCovLinkFacilities('Select linked facilities from the dropdown.');
        //   isCoverageRuralError = true;
        // }
        // else {
        //   setIslinkedFacilitiesRuralError(false);
        //  // setErrorMessageCovLinkVillages('');
        // }
        setIslinkedWardRuralError(false);
        if(isGrampanchayat){
          if (linkedGramPanchayatRural.length === 0 && gramPanchayatCount > 0) {
            setIslinkedGramPanchayatRuralError(true);
            setErrorMessageCovLinkGramPanchayat('Select Gram Panchayats / ADC Villages from the dropdown.');
            isCoverageRuralError = true;
          }
          else {
            setIslinkedGramPanchayatRuralError(false);
          }
      }else{
        if (linkedVillageRural.length === 0 && villagesCount > 0) {
          setIslinkedVillageRuralError(true);
          setErrorMessageCovLinkVillages('Select villages from the dropdown.');
          isCoverageRuralError = true;
        }
        else {
          setIslinkedVillageRuralError(false);
          //setErrorMessageCovLinkFacilities('');
        }
      }
        // isError[5] = isCoverageRuralError;
        isCoverageError=isCoverageRuralError
      }
      else {
        let isCoverageUrbanError = false;
        setIslinkedGramPanchayatRuralError(false);
        setIslinkedVillageRuralError(false);
        // if ((linkedFacilitiesCount>0) && (linkedFacilitiesUrban.length === 0)&&(listOfMandatoryFacilityType.includes(facilityDetailsFormState.facility_type.value))) {
        //   setIslinkedFacilitiesRuralError(true);

        // //  Select linked facilities from the dropdown.
        //   setErrorMessageCovLinkFacilities('Select linked facilities from the dropdown.');
        //   isCoverageUrbanError = true;

        // }
        // else {
        //   setIslinkedFacilitiesRuralError(false);
        //  // setErrorMessageCovLinkVillages('');
        // }
        if (linkedWardRural.length === 0 && wardsCount > 0) {
          setIslinkedWardRuralError(true);
          setErrorMessageCovLinkWard('Select wards from the dropdown.');
          isCoverageUrbanError = true;
        }
        else {
         // setIslinkedFacilitiesRuralError(false);
          setIslinkedWardRuralError(false);
          //setErrorMessageCovLinkFacilities('');
          //setErrorMessageCovLinkWard('');
        }
        // isError[6] = isCoverageUrbanError;
        isCoverageError=isCoverageUrbanError
      }
    }
    isError[5]=isCoverageError;
  }

    //saving the data
    FacilityDetailsFromABDM = Object.keys(ABDMdata).length > 0 ? ABDMdata : FacilityDetailsFromABDM;    
    const ABDMDetailsPayload = {
      abdmFacilityName: FacilityDetailsFromABDM?.facilityName ,
      abdmStatus: FacilityDetailsFromABDM?.facilityStatus,
      abdmOwnership: FacilityDetailsFromABDM?.ownership == "Public-Private-Partnership" ? 'PPP' : FacilityDetailsFromABDM?.ownership,
      abdmOwnershipCode: FacilityDetailsFromABDM?.ownershipCode,
      abdmSystemOfMedicineCode: FacilityDetailsFromABDM?.systemOfMedicineCode,
      abdmSystemOfMedicine: FacilityDetailsFromABDM?.systemOfMedicine,
      abdmFacilityTypeCode: parseInt(FacilityDetailsFromABDM?.facilityTypeCode?.toString(), 10),
      abdmFacilityType: FacilityDetailsFromABDM?.facilityType,
      abdmStateName: FacilityDetailsFromABDM?.stateName,
      abdmStateCode: parseInt(FacilityDetailsFromABDM?.stateLGDCode?.toString(), 10),
      abdmDistrictName: FacilityDetailsFromABDM?.districtName,
      abdmDistrictCode: parseInt(FacilityDetailsFromABDM?.districtLGDCode?.toString(), 10),
      abdmSubDistrictName: FacilityDetailsFromABDM?.subDistrictName,
      abdmSubDistrictCode: parseInt(FacilityDetailsFromABDM?.subDistrictLGDCode?.toString(), 10),
      abdmVillageCityTownName: FacilityDetailsFromABDM?.villageCityTownName,
      abdmVillageCityTownCode: parseInt(FacilityDetailsFromABDM?.villageCityTownLGDCode?.toString(), 10),
      abdmAddress: FacilityDetailsFromABDM?.address,
      abdmPincode: FacilityDetailsFromABDM?.pincode,
      abdmLatitude: parseFloat(FacilityDetailsFromABDM?.latitude?.toString()),
      abdmLongitude: parseFloat(FacilityDetailsFromABDM?.longitude?.toString()),
    }
    let categoryCode: any = facilityDetailsFormState?.facility_category?.code;
    categoryCode = categoryCode?.filter((code: null) => code != null) ?? [];
    
    const ruralFacilityDetails = {
      facilityId: id,
      stCode: hierarchyDetailsRuralFormState.state.code,
      stId: hierarchyDetailsRuralFormState.state.id,
      distId: hierarchyDetailsRuralFormState.district.id,
      distCode: hierarchyDetailsRuralFormState.district.code,
      subDistId: hierarchyDetailsRuralFormState.sub_district.id,
      facilityName: facilityDetailsFormState.facility_name.value ? facilityDetailsFormState.facility_name.value.trim() : '',
      enrollmentDt: dayjs(enrollmentDetailsFormState.date_of_enrollment.value).format('YYYY-MM-DD'),
      urbanRualId: facilityDetailsFormState.rural_urban.id,
      facilityTypeId: facilityDetailsFormState.facility_type.id,
      ownershipId: facilityDetailsFormState.ownership.id,
      adminBodyId: facilityDetailsFormState.administrative_body.id,
      categoryId:facilityDetailsFormState.facility_category.id.length > 0 ? facilityDetailsFormState.facility_category.id:[],
      statusId:enrollmentDetailsFormState.status.id,
      sanctionedBedCount: Number(enrollmentDetailsFormState.sanctionedbed_count.value),
      functionalBedCount: Number(enrollmentDetailsFormState.functionalbed_count.value),
      address: locationDetailsFormState.address.value ? locationDetailsFormState.address.value.trim() : '',
      latitude: locationDetailsFormState.lattitude.value,
      longitude: locationDetailsFormState.longitude.value,
      pincode: locationDetailsFormState.pincode.value,
      effectiveFromDt: dayjs(enrollmentDetailsFormState.effective_from_date.value).format('YYYY-MM-DD'),
      villageIds: !isGrampanchayat?linkedVillageRural.map((item: { village_id: string; }) => item.village_id):[],
      wardIds: linkedWardRural.map((item: { ward_id: string; }) => item.ward_id),
      linkedFacilityIds: linkedFacilitiesRural.map((item: { facility_id: string; }) => item.facility_id),
      hfrId: facilityDetailsFormState.hpr_id.value,
      ulbId: '',
      blockId: hierarchyDetailsRuralFormState.block.id,
      healthBlockId: hierarchyDetailsRuralFormState.health_block.id,
      subDivisionId: hierarchyDetailsRuralFormState.sub_division.id,
      pcId: hierarchyDetailsRuralFormState.parlimentary.id,
      lacId: hierarchyDetailsRuralFormState.lac.id,
      wardId: '',
      villageId: hierarchyDetailsRuralFormState.village.id,
      centralGovtDeptId: facilityDetailsFormState.central_govt_dept.id,
      isFacilityTypeChanged:isFacilityTypeChanged!==facilityDetailsFormState.facility_type.id,
      gramPanchayatId:hierarchyDetailsRuralFormState.gram_panchayat?.id,
      gramPanchayatIds: isGrampanchayat?linkedGramPanchayatRural.map((item: { gram_panchayat_id: string; }) => item.gram_panchayat_id):[],
    }

    const urbanFacilityDetails = {
      facilityId: id,
      stCode: hierarchyDetailsUrbanFormState.state.code,
      stId: hierarchyDetailsUrbanFormState.state.id,
      distId: hierarchyDetailsUrbanFormState.district.id,
      distCode: hierarchyDetailsUrbanFormState.district.code,
      subDistId: hierarchyDetailsUrbanFormState.sub_district.id,
      facilityName: facilityDetailsFormState.facility_name.value ? facilityDetailsFormState.facility_name.value.trim() : '',
      enrollmentDt: dayjs(enrollmentDetailsFormState.date_of_enrollment.value).format('YYYY-MM-DD'),
      urbanRualId: facilityDetailsFormState.rural_urban.id,
      facilityTypeId: facilityDetailsFormState.facility_type.id,
      ownershipId: facilityDetailsFormState.ownership.id,
      adminBodyId: facilityDetailsFormState.administrative_body.id,
      categoryId:facilityDetailsFormState.facility_category.id.length > 0 ? facilityDetailsFormState.facility_category.id:[],
      statusId: enrollmentDetailsFormState.status.id,
      sanctionedBedCount: Number(enrollmentDetailsFormState.sanctionedbed_count.value),
      functionalBedCount: Number(enrollmentDetailsFormState.functionalbed_count.value),
      address: locationDetailsFormState.address.value ? locationDetailsFormState.address.value.trim() : '',
      latitude: locationDetailsFormState.lattitude.value,
      longitude: locationDetailsFormState.longitude.value,
      pincode: locationDetailsFormState.pincode.value,
      effectiveFromDt: dayjs(enrollmentDetailsFormState.effective_from_date.value).format('YYYY-MM-DD'),
      villageIds: !isGrampanchayat?linkedVillageRural.map((item: { village_id: string; }) => item.village_id):[],
      wardIds: linkedWardRural.map((item: { ward_id: string; }) => item.ward_id),
      linkedFacilityIds: linkedFacilitiesUrban.map((item: { facility_id: string; }) => item.facility_id),
      hfrId: facilityDetailsFormState.hpr_id.value,
      ulbId: hierarchyDetailsUrbanFormState.ulb.id,
      blockId: '',
      healthBlockId: hierarchyDetailsUrbanFormState.health_block.id,
      subDivisionId: hierarchyDetailsUrbanFormState.sub_division.id,
      pcId: hierarchyDetailsUrbanFormState.parlimentary.id,
      lacId: hierarchyDetailsUrbanFormState.lac.id,
      wardId: hierarchyDetailsUrbanFormState.ward.id,
      villageId: '',
      centralGovtDeptId: facilityDetailsFormState.central_govt_dept.id,
      isFacilityTypeChanged:isFacilityTypeChanged!==facilityDetailsFormState.facility_type.id,
      gramPanchayatId:'',
      gramPanchayatIds: isGrampanchayat?linkedGramPanchayatRural.map((item: { gram_panchayat_id: string; }) => item.gram_panchayat_id):[],
    }

    let hfrPresentInABDM;
    if (facilityDetailsFormState?.hpr_id?.value?.length > 0) {
      try {
        const res = await axios.get(`${endpoints.checkFacilityExistInABDM(facilityDetailsFormState?.hpr_id?.value)}`, Auth.loggedIn());
        if (res.status === 200) {
          hfrPresentInABDM = res?.data?.data?.[0]?.check_hfr_in_abdm_facility;
        }
      } catch (error: any) {
        setLoading(false);
        errorLogger(error?.response?.data || error?.response || error)
      }
    }
    setLoading(true);
    const isRural = facilityDetailsFormState.rural_urban.value === 'Rural';
    const isABDMUpdateRequired = Object.keys(abdmFacilityData)?.length > 0 || facilityDetailsFormState?.hpr_id?.value?.length > 0;
    const isABDMInsertRequired = (facilityDetailsFormState?.hpr_id?.value?.length > 0) && (hfrIdCheck !== facilityDetailsFormState.hpr_id.value) && !hfrPresentInABDM;
    let payload ;
    if (!isError.includes(true)) {
      if (isRural) {
        payload = {
          ...ruralFacilityDetails,
          ...(isABDMUpdateRequired ? ABDMDetailsPayload : {}),
          isABDMInsertRequired,
          isABDMUpdateRequired
        };
      }
      else{
        payload = {
          ...urbanFacilityDetails,
          ...(isABDMUpdateRequired ? ABDMDetailsPayload : {}),
          isABDMInsertRequired,
          isABDMUpdateRequired
        }
      }
      await updateFacilityDetails(payload,isABDMInsertRequired, hfrPresentInABDM);
    }
    setLoading(false);
  }

  //Pop Up
  const [selectionLF, setSelectionLF] = useState<boolean>(false);
  const [selectionVillages, setSelectionVillages] = useState<boolean>(false);
  const [selectionGramPanchayats, setSelectionGramPanchayats] = useState<boolean>(false);
  const [selectionWards, setSelectionWards] = useState<boolean>(false);


  const getSelectionFacilitiesRural = async (blockId: any, facilityTypeId:any) => {
    try {
      if(blockId && facilityTypeId && id){
        const data={
          "blockId":blockId,
          "facilityTypeId":facilityTypeId,
          "facilityId":id
        }
      const getSelectionFacilitiesRuralData = await axios.post(`${endpoints.getLinkedFacilitiesByblockId}`,data,Auth.loggedInWithJSON());
      const linkedFaciltiesOptions: any = [];
      getSelectionFacilitiesRuralData.data.data.map((e: any) => {
        linkedFaciltiesOptions.push(e.facility_name)
      })
      setLinkedFacilitiesCount(getSelectionFacilitiesRuralData.data.meta.numberOfRecords);      
      setLinkedFacilities(getSelectionFacilitiesRuralData.data.data);
      setLinkedFacilitiesDetails(getSelectionFacilitiesRuralData.data.data);      
    }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
    }
  }



  const getSelectionFacilitiesUrban = async (ulbId: any, facilityTypeId:any) => {
    try {
      if(ulbId && facilityTypeId && id){
        const data={
          "ulbId":ulbId,
          "facilityTypeId":facilityTypeId,
          "facilityId":id
        }
      const getSelectionFacilitiesUrbanData = await axios.post(`${endpoints.getLinkedFacilitiesByUlbId}`,data,Auth.loggedInWithJSON());
      const linkedFaciltiesOptions: any = [];
      getSelectionFacilitiesUrbanData.data.data.map((e: any) => {
        linkedFaciltiesOptions.push(e.facility_name)
      })
      setLinkedFacilitiesCount(getSelectionFacilitiesUrbanData.data.meta.numberOfRecords);      
      setLinkedFacilities(getSelectionFacilitiesUrbanData.data.data);
      setLinkedFacilitiesDetails(getSelectionFacilitiesUrbanData.data.data);
    }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
    }
  }

  const getSelectionVillages = async (blockId: any,subDistrictId:any, healthBlockId: any, subDivisionId: any) => {
    try {
      let getSelectionVillagesData: any;
      if (blockId || healthBlockId || subDivisionId) {
        const params = {
          'blockId': blockId,
          'healthBlockId': healthBlockId,
          'subDivisionId': subDivisionId,
        };

        setVillagesPayLoad(params);

        const postData = {
          p_state_id: facility.state_id,
          p_dist_id: facility.district_id,
          p_sub_dist_ids: subDistrictId ? [subDistrictId] : [],
          p_block_ids: [blockId],
          p_hbsd_ids: [],
        }
        if (!blockId && (healthBlockId || subDivisionId)) {
          setHBSDSelected(true);
          getSelectionVillagesData = await axios.post(`${endpoints.fetchVillageByBlockHBSD}`, params, Auth.loggedInWithJSON());
        }
        else {
          setHBSDSelected(false);
          getSelectionVillagesData = await axios.post(`${endpoints.getVillagesByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
        }
        const villagesCoveredOptions: any = [];
        getSelectionVillagesData.data.data.map((e: any) => {
          villagesCoveredOptions.push(e.village_name)
        })

        setVillagesCount(getSelectionVillagesData.data.meta.numberOfRecords);
        setVillages(getSelectionVillagesData.data.data);
        setVillagesDetails(getSelectionVillagesData.data.data);
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }
  }

  const getSelectionGramPanchayats = async (blockId: any, subDistrictId:any, healthBlockId: any, subDivisionId: any) => {
    try {
      if (blockId || healthBlockId || subDivisionId) {
        const params = {
          'blockId': blockId,
          'healthBlockId': healthBlockId,
          'subDivisionId': subDivisionId,
        };
        const postData = {
          p_state_id: facility.state_id,
          p_dist_id: facility.district_id,
          p_sub_dist_ids: subDistrictId ? [subDistrictId] : [],
          p_block_ids: [blockId],
          p_hbsd_ids: [],
        }
        let getSelectionGrampanchayatData: any;
        if (!blockId && (healthBlockId || subDivisionId)) {
          setHBSDSelected(true);
          getSelectionGrampanchayatData = await axios.post(`${endpoints.fetchGramPanchayatByBlockHBSD}`, params, Auth.loggedInWithJSON());
        }
        else {
          getSelectionGrampanchayatData = await axios.post(`${endpoints.getGrampanchayatByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
          setHBSDSelected(false);
        }

        const gramPanchayatCoveredOptions: any = [];
        getSelectionGrampanchayatData.data.data.map((e: any) => {
          gramPanchayatCoveredOptions.push(e.gram_panchayat_name)
        })

        setGramPanchayatCount(getSelectionGrampanchayatData.data.meta.numberOfRecords);
        setGramPanchayats(getSelectionGrampanchayatData.data.data);
        setGramPanchayatsDetails(getSelectionGrampanchayatData.data.data);
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error)
    }
  }

  const getSelectionWards = async (ulbId: any, healthBlockId:any, subDivisionId:any) => {
    try {
      if(!ulbId && (healthBlockId || subDivisionId)){
        setHBSDSelected(true);
      }
      else{
        setHBSDSelected(false);
      }
      if(ulbId || healthBlockId || subDivisionId){
        const params = {
          'ulbId': ulbId,
          'healthBlockId': healthBlockId,
          'subDivisionId': subDivisionId,
        };
        setWardssPayLoad(params);
        const getSelectionWardsData = await axios.post(`${endpoints.fetchWardByUlbHBSD}`,params,Auth.loggedIn());

      const wardsCoveredOptions: any = [];
      getSelectionWardsData.data.data.map((e: any) => {
        wardsCoveredOptions.push(e.ward_name)
      })

      setWardsCount(getSelectionWardsData.data.meta.numberOfRecords)

      setWards(getSelectionWardsData.data.data);
      setWardsDetails(getSelectionWardsData.data.data);
    }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error,"Health Facility Update")
    }
  }




  const [linkedFacilities, setLinkedFacilities] = useState([]);
  const [linkedFacilitiesCount,setLinkedFacilitiesCount] = useState<any>(0);
  const [villages, setVillages] = useState([]);
  const [gramPanchayats, setGramPanchayats] = useState([]);
  const [villagesCount, setVillagesCount] = useState<any>(0);
  const [villagesPayLoad, setVillagesPayLoad] = useState<any>(null);
  const [gramPanchayatCount, setGramPanchayatCount] = useState<any>(0);
  const [wards, setWards] = useState([]);
  const [wardsCount, setWardsCount] = useState<any>(0);
  const [wardsPayLoad, setWardssPayLoad] = useState<any>(null);
  

  const [linkedFacilitiesDetails, setLinkedFacilitiesDetails] = useState<any>({});
  const [villagesDetails, setVillagesDetails] = useState<any>({});
  const [gramPanchayatsDetails, setGramPanchayatsDetails] = useState<any>({});
  const [wardsDetails, setWardsDetails] = useState<any>({});

  const [savedLF, setSavedLF] = useState<any>({})
  const [savedVillages, setSavedVillages] = useState<any>({})
  const [savedWards, setSavedWards] = useState<any>({})


  const onhandleSaveLFUrban = (selectedItems: any[], flag: boolean) => {
    setLinkedFacilitiesUrban(selectedItems);
    setSelectionLF(flag);
  }



  const onhandleSaveLFRural = (selectedItems: any[], flag: boolean) => {
    setLinkedFacilitiesRural(selectedItems);
    setSelectionLF(flag);
  }


  


  

  const onhandleOpenLFRural = () => {
    getSelectionFacilitiesRural(hierarchyDetailsRuralFormState.block.id, facilityDetailsFormState.facility_type.id);
    setSelectionLF(true);
  }

  const onhandleOpenLFUrban = () => {
    getSelectionFacilitiesUrban(hierarchyDetailsUrbanFormState.ulb.id, facilityDetailsFormState.facility_type.id);
    setSelectionLF(true);
  }



  const onhandleSaveVillages = (selectedItems: any[], flag: boolean) => {
    setLinkedVillageRural(selectedItems);
    setSelectionVillages(flag);
  }

  const onhandleOpenVillages = () => {
    setSelectionVillages(true);
  }

  const onhandleSaveGramPanchayats = (selectedItems: any[], flag: boolean) => {
    setLinkedGramPanchayatRural(selectedItems);
    setSelectionGramPanchayats(flag);
  }

  const onhandleOpenGramPanchayats = () => {
    setSelectionGramPanchayats(true);
  }


  const onhandleSaveWards = (selectedItems: any[], flag: boolean) => {
    setLinkedWardRural(selectedItems);
    setSelectionWards(flag);
  }



  const onhandleOpenWards = () => {
    const healthBlockId =facilityDetailsFormState?.rural_urban?.value==='Rural'? hierarchyDetailsRuralFormState?.health_block?.id:hierarchyDetailsUrbanFormState?.health_block?.id;
    const subDivisionId =facilityDetailsFormState?.rural_urban?.value==='Rural'? hierarchyDetailsRuralFormState?.sub_division?.id:hierarchyDetailsUrbanFormState?.sub_division?.id;
    if(!healthBlockId && !subDivisionId){
      getSelectionWards(hierarchyDetailsUrbanFormState?.ulb?.id,'','');
    }
    else{
      getSelectionWards('',healthBlockId,subDivisionId);
    }
    setSelectionWards(true);
  }

  const getAddressUsingLatLong = async (lattitude :any, longitude:any) => {
    // if(!longitude) {
    //   setLocationDetailsFormState((prevState) => {
    //    return {
    //     ...prevState,
    //     lattitude : {
    //       ...prevState.lattitude,
    //       isError: true,
    //       message: 'Enter valid latitude to continue.',
    //     }
    //    } 
    //   });
    // }
    // if(!locationDetailsFormState.longitude.value) {
    //   setLocationDetailsFormState((prevState) => {
    //    return {
    //     ...prevState,
    //     longitude : {
    //       ...prevState.longitude,
    //       isError: true,
    //       message: 'Enter valid longitude to continue.',
    //     }
    //    } 
    //   });
    // }
    // if(!locationDetailsFormState.lattitude.value || !locationDetailsFormState.longitude.value) return;
  
    const response = await validateMapLocation(lattitude, longitude);
    
    if(response) {
      setLocationDetailsFormState((prevState) => {
        return {
         ...prevState,
         lattitude : {
          ...prevState.lattitude,
          isError: false,
          message: '',
        },
        longitude : {
          ...prevState.longitude,
          isError: false,
          message: '',
        },
        pincode : {
          ...prevState.pincode,
          isError: false,
          message: '',
          value: response.pincode
        },
        address : {
        ...prevState.pincode,
        isError: false,
        message: '',
        value: response.address
        }
        } 
      });
    }
  }

  const handleLocationDetailsDataChangeOnMapFails = useCallback((data: any) => {
    setlocationDetailsFormData((prevState: any) => ({
      ...prevState,
      lattitude: {
        '#type': 'textfield',
        '#title': 'Lattitude',
        '#webform_key': 'lattitude',
        '#required': true,
        '#isDisabled': data ? data : false,
      },
      longitude: {
        '#type': 'textfield',
        '#title': 'Longitude',
        '#webform_key': 'longitude',
        '#required': true,
        '#isDisabled': data ? data : false,
      },
      address: {
        '#type': 'textfield',
        '#title': 'Address',
        '#webform_key': 'address',
        '#required': true,
        '#isDisabled': data ? data : false,
      },
    }));
  }, []);

  const facilityFormState = facilityDetailsFormState.rural_urban.value === 'Rural' ? hierarchyDetailsRuralFormState : hierarchyDetailsUrbanFormState;

  return (
    <>
    { loading ? <div className='loader'>Loading...</div>:
      <div className='upgrade_facility_mangement'>
        <div className="upgrade_facility">           
          <div className='radio-button'>
            <p>Edit Type:   </p>
            {status === "Inactive" && <><Radio data={"Correction"} link={`/health-facility/update/${id}`} isChecked={true} isDisabled={false} /><Radio data={"Upgrade"} link={`/health-facility/upgrade/${id}`} isChecked={false} isDisabled={true} /></>}
            {status !== "Inactive" && <><Radio data={"Correction"} link={`/health-facility/update/${id}`} isChecked={true} isDisabled={false} /><Radio data={"Upgrade"} link={`/health-facility/upgrade/${id}`} isChecked={false} isDisabled={false} /></>}


          </div>
          <BadgesComponent
            className="over-badge"
            badgeName="Facility Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details-upgrade">
            <div className="upgrade_facility_details_page">
              <form className="upgrade_form_container_facility_details">
                <HealthFormField
                  formData={formData1}
                  formState={facilityDetailsFormState}
                  handleFormChange={(value: any, key: string, id: any, option: any, code: any) => {
                    if (key === 'facility_category') {
                      id = [];
                      option.length > 0 && value.length > 0 && option.forEach((op: any) => {
                        if (value.includes(op.value)) {
                          id.push(op.id);
                        }
                      });
                      code = [];
                      option.length > 0 && value.length > 0 && option.forEach((op: any) => {
                        if (value.includes(op.value)) {
                          code.push(op.code);
                        }
                      });
                    }
                    if (key == 'hpr_id' || key == 'facility_name') {
                      setVerify(false);
                      setClickVerify(false);
                      setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
                        ...facilityDetailsFormState,
                        hpr_id: {
                          ...facilityDetailsFormState.hpr_id,
                          verifiedDetails: 'not verified',
                        },
                      }));
                    }
                    handleFacilityDetailsFormChange(value, key, id, code);
                  }}
                  // handleFormChange={handleFacilityDetailsFormChange}
                  verified={verify}
                  onClickVerify={onClickVerify}
                />
              </form>
              {verify && clickVerify &&
                <HFRVerify closeVerifyModal={closeVerifyModal} onClickNext={onClickNext} facilityVerify={abdmFacilityData} matchingScore={matchingScore} action='update' />
              }

            </div>
            <hr></hr>
          </div>
        </div>
        <div className="upgrade_ABDM">
          <BadgesComponent
            className="over-badge"
            badgeName="ABDM Facility Details"
            variant="primary-1"
            badgeType="case5"
          />
          <a onClick={abdmOnClick} className='abdm_link_verify'>ABDM details</a>
          {abdmClickVerify && <ABDMVerify closeVerifyModal={closeABDMLocalModal} facilityVerify={abdmLocalData} />}
          <hr></hr>
        </div>
        <div className="upgrade_enrollment">
          <BadgesComponent
            className="over-badge"
            badgeName="Enrollment Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details-upgrade">
            <div className="upgrade_enrolment_details_page">
              <form className="upgrade_form_container_enrolment_details">
                <HealthFormField
                  formData={formData2}
                  formState={enrollmentDetailsFormState}
                  handleFormChange={handleEnrollmentDetailsFormChange}
                />
              </form>
            </div>
          </div>
          <hr></hr>
        </div>
        <div className="upgrade_hierarchy">
          <BadgesComponent
            className="over-badge"
            badgeName="Hierarchy Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details-upgrade">
            <div className="upgrade_hierarchy_page">
              <form className="upgrade_hierarchy_page">
                <HealthFormField
                  formData={facilityDetailsFormState.rural_urban.value === 'Rural' ? formData3_2 : formData3_1}
                  formState={facilityDetailsFormState.rural_urban.value === 'Rural' ? hierarchyDetailsRuralFormState : hierarchyDetailsUrbanFormState}
                  handleFormChange={handleHierarchyDetailsFormChange}
                  onInputChange={handleInputChange}
                />
              </form>
            </div>
          </div>
          <hr></hr>
        </div>
        <div className="upgrade_location">
          <BadgesComponent
            className="over-badge"
            badgeName="Location Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details-upgrade">
            <LocationDetailsEdit formData={locationDetailsFormData} formState={locationDetailsFormState} handleLocationDetailsDataChangeOnMapFails={handleLocationDetailsDataChangeOnMapFails} handleFormChange={handleLocationDetailsFormChange} handleLocationDetailsError={handleLocationDetailsError} facilityFormState={facilityDetailsFormState.rural_urban.value === 'Rural' ? hierarchyDetailsRuralFormState : hierarchyDetailsUrbanFormState}/>
          </div>
          <hr></hr>
        </div>
        <div className="upgrade_coverage">
          <BadgesComponent
            className="over-badge"
            badgeName="Coverage Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details-upgrade">
            <div className="upgrade_coverage_details_page">
              {facilityDetailsFormState.rural_urban.value === 'Rural' && (
                <div className='coverage_rural_facility_village'>
                  <div className='coverage_rural_facility'>
                    {
                      <CoverageCardComponent listItems={formatLinkedFacility(linkedFacilitiesRural, 'linked-facility')} required={false}
                        onUnlink={handleRuralFacilityUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenLFRural} linkButtonName={'Link'} labelforCoverage={'Linked Facilities'} inputType={islinkedFacilitiesRuralError ? 'error' : ''} errorMessage={errorMessageCovLinkFacilities} linkButtonStatus={linkedFacilitiesCount} />
                    }
                  </div>
                  <div className='coverage_urban_ward'>
                    {
                      <CoverageCardComponent listItems={formatLinkedFacility(linkedWardRural, 'ward')} inputType={islinkedWardRuralError ? 'error' : ''}  required={wardsCount>0} errorMessage={errorMessageCovLinkWard}
                        onUnlink={handleWardUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenWards} linkButtonName={'Link'} labelforCoverage={'Linked Wards'}  linkButtonStatus={wardsCount}/>
                    }
                  </div>
                  <div className='coverage_rural_village'>
                    {
                      isGrampanchayat ?
                      <CoverageCardComponent listItems={formatLinkedFacility(linkedGramPanchayatRural, 'gram_panchayat')}  required={gramPanchayatCount>0} inputType={islinkedGramPanchayatRuralError ? 'error' : ''} errorMessage={errorMessageCovLinkGramPanchayat}
                        onUnlink={handleGramPanchayatUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenGramPanchayats} linkButtonName={'Link'} labelforCoverage={'Linked Gram Panchayats / ADC Villages'} linkButtonStatus={gramPanchayatCount}/> 
                      :
                      <CoverageCardComponent listItems={formatLinkedFacility(linkedVillageRural, 'village')}  required={villagesCount>0} inputType={islinkedVillageRuralError ? 'error' : ''} errorMessage={errorMessageCovLinkVillages}
                        onUnlink={handleVillageUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenVillages} linkButtonName={'Link'} labelforCoverage={'Linked Villages'} linkButtonStatus={villagesCount}/>   
                    }
                  </div>
                </div>
              )}
              {facilityDetailsFormState.rural_urban.value !== 'Rural' && (
                <div className='coverage_urban_facility_ward'>
                  <div className='coverage_urban_facility'>
                    {
                      <CoverageCardComponent listItems={formatLinkedFacility(linkedFacilitiesUrban, 'linked-facility')}  required={false}
                        onUnlink={handleUrbanFacilityUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenLFUrban} linkButtonName={'Link'} labelforCoverage={'Linked Facilities'} inputType={islinkedFacilitiesRuralError ? 'error' : ''} errorMessage={errorMessageCovLinkFacilities} linkButtonStatus={linkedFacilitiesCount}  />
                    }
                  </div>
                  <div className='coverage_urban_ward'>
                    {
                      <CoverageCardComponent listItems={formatLinkedFacility(linkedWardRural, 'ward')} inputType={islinkedWardRuralError ? 'error' : ''}  required={wardsCount>0} errorMessage={errorMessageCovLinkWard}
                        onUnlink={handleWardUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenWards} linkButtonName={'Link'} labelforCoverage={'Linked Wards'}  linkButtonStatus={wardsCount}/>
                    }
                  </div>
                  <div className='coverage_rural_village'>
                    {
                      isGrampanchayat ?
                      <CoverageCardComponent listItems={formatLinkedFacility(linkedGramPanchayatRural, 'gram_panchayat')}  required={gramPanchayatCount>0} inputType={islinkedGramPanchayatRuralError ? 'error' : ''} errorMessage={errorMessageCovLinkGramPanchayat}
                        onUnlink={handleGramPanchayatUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenGramPanchayats} linkButtonName={'Link'} labelforCoverage={'Linked Gram Panchayats / ADC Villages'} linkButtonStatus={gramPanchayatCount}/> 
                      :
                      <CoverageCardComponent listItems={formatLinkedFacility(linkedVillageRural, 'village')}  required={villagesCount>0} inputType={islinkedVillageRuralError ? 'error' : ''} errorMessage={errorMessageCovLinkVillages}
                        onUnlink={handleVillageUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenVillages} linkButtonName={'Link'} labelforCoverage={'Linked Villages'} linkButtonStatus={villagesCount}/>   
                    }
                  </div>
                </div>
              )}

              {facilityDetailsFormState.rural_urban.value === 'Rural' && selectionLF && (
                <SelectionModal items={linkedFacilities} onSave={onhandleSaveLFRural} title='Linked Facilities Selected' searchPlaceholder='Search By Linked Facilities'  selectedItemsProps={linkedFacilitiesRural} />
              )}
              {facilityDetailsFormState.rural_urban.value !== 'Rural' && selectionLF && (
                <SelectionModal items={linkedFacilities} onSave={onhandleSaveLFUrban} title='Linked Facilities Selected' searchPlaceholder='Search By Linked Facilities' selectedItemsProps={linkedFacilitiesUrban} />
              )}
              {selectionVillages && (
                <SelectionModal items={villages} onSave={onhandleSaveVillages} title='Villages Selected' searchPlaceholder={'Search By Villages'}  selectedItemsProps={linkedVillageRural} />
              )}
              {selectionGramPanchayats && (
                <SelectionModal items={gramPanchayats} onSave={onhandleSaveGramPanchayats} title='Gram Panchayat / ADC Village Selected' searchPlaceholder={'Search By Gram Panchayat / ADC Village'}  selectedItemsProps={linkedGramPanchayatRural} />
              )}
              {selectionWards && (
                <SelectionModal items={wards} onSave={onhandleSaveWards} title='Wards Selected' searchPlaceholder={'Search By Wards'}  selectedItemsProps={linkedWardRural} />

              )}



            </div>
          </div>
        </div>

      </div>}
    </>
  )
});
HealthFacilityUpdateUi.displayName = 'HealthFacilityUpdateUi';

export default HealthFacilityUpdateUi;